import * as Sentry from "@sentry/browser"; // error tacking
import * as collectionsActions from "actions/collections";
import {
    bulkMutateAllocationBag,
    completeFetchingExportLogs,
    fetchExportLogs,
    ICopyProps,
    initDependentsFieldsLookupMap,
    mutateCollectionItem,
    setTransientExportCount,
    updateCollectionReports,
} from "actions/collections";
import { sizePacksFetchComplete } from "actions/collections/collection-size-packs";
import {
    listCreate,
    mapCreate,
    mapSetOperation,
    mixedCreate,
    MutableType,
    updateSnapshotFromCommitted,
} from "actions/mutate";
import { add as snackbarAdd } from "actions/snackbars";
import { ColumnApi } from "ag-grid-community";
import { getGenericAllocationDimensions } from "components/product-collection";
import { SaveAssormentSettingsRequest } from "components/product-collection/market-settings/market-settings.types";
import { COLLECTIONS, MUTATE_CLEAR, NOOP, SUBSCRIPTION } from "constants/action-types";
import { ExportItemPo, EXPORT_ASSORTMENT_TO_MERCHANT } from "constants/analytics";
import {
    ALLOCATION_BAG_ID,
    ALLOCATION_BAG_NAMESPACE,
    ALLOCATION_DIMENSIONS_NAMESPACE,
    ALLOCATION_DIMENSION_ID_PREFIX,
    CollectionKeys,
    COLLECTION_FEED_SLUG,
    COLLECTION_POI_TAGS_NAMESPACE,
    DEFAULT_ITEM_NAMESPACE,
    DELIVERY_PURCHASE_ORDERS_NAMESPACE,
    EXCEL_STYLES,
    ExportRequestType,
    EXPORT_STATUS,
    EXPORT_VALIDATION_STATUS_NAMESPACE,
    IExportParams,
    IMAGE_URL,
    Item,
    ITEMS_ID,
    ITEMS_NAMESPACE,
    ITEM_DISPLAY_PREFERENCES_NAMESPACE,
    MERCHANT_ITEM_DISPLAY_PREFERENCES_NAMESPACE,
    TARGETS_NAMESPACE,
    TARGET_GROUPS_NAMESPACE,
    NAMESPACE_KEYS,
    REVIEW_DISPLAY_PREFERENCES_NAMESPACE,
    REVIEW_PLANS_NAMESPACE,
    ROOT_NAMESPACE,
    USER_COLORS,
    TARGET_BAG_ID,
    TARGET_BAG_NAMESPACE,
    TARGET_GROUPS_ID,
    TARGETS_ID,
} from "constants/product-collection";
import { isRollupContainingTrashedItem, removeAssortmentExtRegex } from "containers/folders/hooks/utils";
import { CollectionType } from "containers/folders/types/assortment";
import { ItemKind } from "containers/folders/types/base";
import { RollupType } from "containers/folders/types/server-rollups";
import { DRIVE_LINK, pathToRootDrive } from "containers/folders/utils/constants";
import { nameExtRemover } from "containers/folders/utils/space-item";
import {
    AllocationDimensionIndex,
    AllocationDimensionKind,
    generatePOCreationStatusMutations,
    getAllocationDimensionByIndex,
} from "helpers/allocation-dimension";
import {
    derivePOTableFromItem,
    getLocalAssortmentSchema,
    getMutationBatchSizeByObjectId,
    regexForGetAllCharacterNotAlphanumeric,
} from "helpers/collection";
import {
    deleteAllocationDimensionsFromStoreIfNeeded,
    readAllocationDimensionsFromStore,
} from "helpers/collection-objects";
import { appendDateSuffix, dateFormat } from "helpers/dates";
import { batchMutations, coerceOperationTransform, getOperationTransforms, mutateSnapshot } from "helpers/mutable";
import { amphibiousGetIn } from "helpers/objUtils";
import { SchemaKeyMap, setValueToLocalStorage, translateItemsList } from "helpers/product-collection";
import { buildFilterProductByIdQuery } from "helpers/query-dsl-builder";
import { buildServerRollupRowNodeId, readRows, shouldRecreateSnapshot } from "helpers/server-rollup";
import { buildServerRollupSchema, getAllocationDimensionsOrder } from "helpers/server-rollup-schema";
import { WindowAnalytics } from "helpers/window-analytics";
import { fromJS, List, Map } from "immutable";
import { getRecordsFromSchema, normalizeData } from "lib/api";
import app from "lib/app";
import dbService from "lib/dexie-db-service";
import { APIError } from "lib/errors";
import { formatMessage } from "lib/globalize-util";
import { stream } from "lib/ndjson-rxjs";
import { ajax } from "lib/observable";
import get from "lodash/get";
import groupBy from "lodash/groupBy";
import pick from "lodash/pick";
import set from "lodash/set";
import me from "models/me";
import moment from "moment";
import { stringify } from "query-string";
import { push } from "react-router-redux";
import { IStore } from "reducers";
import { ICollectionState, IDoorTotals } from "reducers/collection";
import {
    DEFAULT_ITEM_OBJECT_ID_PATH,
    EXPORT_VALIDATION_LOG_OBJECT_ID_PATH,
    getAllocationDimensions,
    getAllocationDimensionsBySubtype,
    getCollectionAllocationBag,
    getCollectionItems,
    getDoors,
    getReviewPlanFromState,
    POI_TAGS_OBJECT_ID_PATH,
} from "reducers/selectors/collection";
import { updateEntities } from "redux-query";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { ChatMessage as ChatMessagesSchema, Collections as CollectionsSchema } from "schemas/collections";
import siteConfig from "site-config";
import * as superagent from "superagent";
import {
    addAssortmentNameField,
    aggregateCollectionAllocationDimensions,
    aggregateDataToBaseCollection,
    enableAllSelectedDimensions,
    setAssortmentName,
} from "./helpers/rollups";

import { hasLocalSchemasEnabled } from "hooks/useMerchantSchema";

import {
    getColumnsForExportUpcs,
    prepareRequestBodyForCopyCollection,
    prepareRequestBodyForExportAssortment,
    prepareRequestBodyForExportRollup,
    trackEventExportAssortment,
    trackEventExportRollup,
} from "./helpers/collection";
import { shouldRecalculateTotals } from "./helpers/totals";

const VALID_OPERATIONS = [
    "insert",
    "move",
    "remove",
    "set",
    "list_insert",
    "list_move",
    "list_set",
    "list_remove",
    "map_set",
    "map_remove",
    "map_clear",
];

export const deleteCollectionEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.DELETE.START)
        .map(({ payload }) => payload)
        .mergeMap(({ id }) => {
            const { merchantId = me.getLastMerchantId(), collectionItemId } = store.getState().collection;

            return ajax({
                url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/space/items/${collectionItemId}?recursive_delete=true`,
                method: "DELETE",
            })
                .mergeMap(() => {
                    const { routing } = store.getState();

                    const successActions = [
                        collectionsActions.deleteCollectionSuccess(id),
                        store.dispatch(snackbarAdd({ message: formatMessage("Assortment successfully deleted") })),
                    ];

                    if (routing.locationBeforeTransitions.pathname.includes("/assortment/")) {
                        successActions.push(push(pathToRootDrive(merchantId)));
                    }

                    return successActions;
                })
                .catch((error) => {
                    const { routing } = store.getState();
                    if (
                        error &&
                        error.status === 404 &&
                        routing.locationBeforeTransitions.pathname.includes("/assortment/")
                    ) {
                        // we've attempted to delete one that does not exist anymore
                        // most likely trying to delete one that has already been deleted
                        return Observable.merge(
                            Observable.of(push(DRIVE_LINK)),
                            store.dispatch(snackbarAdd({ message: formatMessage("Assortment successfully deleted") }))
                        );
                    } else {
                        let errorMessage = formatMessage("There was an error deleting your assortment");
                        if (error.status === 401 || error.status === 403) {
                            errorMessage = formatMessage("You do not have permission to delete this assortment");
                        }
                        return Observable.merge(
                            Observable.of(collectionsActions.deleteCollectionError(error, true)),
                            Observable.of(snackbarAdd({ message: errorMessage }))
                        );
                    }
                });
        });

export const fetchCollectionDriveItemEpic = (action$) => {
    return action$.ofType(COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.START).concatMap(({ payload }) => {
        const { userMerchantId, itemId, rollupSnapshotId, collectionIds, rollupSnapshotData } = payload;

        if (rollupSnapshotId) {
            /* No need to hit the below APIs if rollup has a trashed assortment. */
            if (isRollupContainingTrashedItem(rollupSnapshotData)) {
                return Observable.of({
                    payload: {
                        rollupSnashot: rollupSnapshotData,
                    },
                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.COMPLETED,
                });
            }
            return ajax(`${siteConfig.goAPI}/v1/merchants/${userMerchantId}/space/items/${rollupSnapshotId}`)
                .flatMap(({ response: rollupSnapshot }) => {
                    return ajax(
                        `${siteConfig.goAPI}/v1/merchants/${userMerchantId}/space/items/${rollupSnapshot.parent}`
                    ).flatMap(({ response: snapshotFolder }) => {
                        return ajax(
                            `${siteConfig.goAPI}/v1/merchants/${userMerchantId}/space/items/${snapshotFolder.parent}`
                        ).flatMap(({ response: rollupFolder }) => {
                            if (!collectionIds?.length) {
                                return Observable.of({
                                    payload: rollupFolder,
                                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.COMPLETED,
                                });
                            }

                            return Observable.merge(
                                Observable.of({
                                    payload: rollupFolder,
                                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.COMPLETED,
                                }),
                                Observable.of({
                                    payload: {
                                        merchantId: userMerchantId,
                                        rollupItemId: rollupFolder.id,
                                        collectionIds: collectionIds,
                                    },
                                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.CREATE_ROLLUP_SNAPSHOT.START,
                                })
                            );
                        });
                    });
                })
                .catch((error) => {
                    return Observable.of({
                        error: true,
                        payload: error.xhr
                            ? new APIError(error.xhr.response.error, error.xhr.status, error.xhr.statusText)
                            : error,
                        type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.COMPLETED,
                    });
                });
        }

        return ajax(`${siteConfig.goAPI}/v1/merchants/${userMerchantId}/space/items/${itemId}`)
            .flatMap((res) => {
                return Observable.of({
                    payload: res.response,
                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.COMPLETED,
                });
            })
            .catch((error) => {
                const apiError = error.xhr
                    ? new APIError(error.xhr.response.error, error.xhr.status, error.xhr.statusText)
                    : error;

                return Observable.merge(
                    Observable.of({
                        error: true,
                        payload: apiError,
                        type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.COMPLETED,
                    }),
                    Observable.of({
                        error: true,
                        payload: apiError,
                        type: COLLECTIONS.COLLECTION.FETCH.COMPLETED,
                    })
                );
            });
    });
};

export const createServerRollupSnapshotEpic = (action$) => {
    return action$.ofType(COLLECTIONS.COLLECTION.DRIVE_ITEM.CREATE_ROLLUP_SNAPSHOT.START).concatMap(({ payload }) => {
        const { merchantId, rollupItemId, collectionIds } = payload;

        return ajax({
            body: {
                merchant_id: merchantId,
                parent_id: rollupItemId,
                collection_ids: collectionIds,
                name: appendDateSuffix(rollupItemId, true),
            },
            method: "POST",
            url: `${siteConfig.goAPI}/v1/collections/rollup_snapshots`,
        })
            .flatMap((res) => {
                return Observable.of({
                    payload: res.response.data,
                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.CREATE_ROLLUP_SNAPSHOT.COMPLETED,
                });
            })
            .catch((error) => {
                return Observable.of({
                    error: true,
                    payload: error.xhr
                        ? new APIError(error.xhr.response.error, error.xhr.status, error.xhr.statusText)
                        : error,
                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.CREATE_ROLLUP_SNAPSHOT.COMPLETED,
                });
            });
    });
};

export const fetchServerRollupSnapshotItemEpic = (action$, store) => {
    return action$.ofType(COLLECTIONS.COLLECTION.ROLLUP_SNAPSHOT_ITEM.FETCH.START).concatMap(({ payload }) => {
        const { merchantId, snapshotId, itemId, collectionId, itemDisplayProperty } = payload;
        const { mutate, collection } = store.getState();
        if (collection.snapshotItems.get(buildServerRollupRowNodeId(itemId, collectionId))) {
            return Observable.empty();
        }

        return ajax({
            body: buildFilterProductByIdQuery(merchantId, itemId, collectionId),
            method: "POST",
            url: `${siteConfig.goAPI}/v1/collections/rollup_snapshots/${snapshotId}/read`,
        })
            .flatMap((res) => {
                const collectionSnapshot = mutate.snapshots && mutate.snapshots.get(snapshotId);
                const collectionsRefs = collectionSnapshot?.getIn(["collections_refs"]);
                const [currentProduct] = readRows(res.response, 0, collectionsRefs, itemDisplayProperty);
                return Observable.of({
                    payload: { itemId, currentProduct },
                    type: COLLECTIONS.COLLECTION.ROLLUP_SNAPSHOT_ITEM.FETCH.COMPLETED,
                });
            })
            .catch((error) => {
                return Observable.of({
                    error: true,
                    payload: error.xhr
                        ? new APIError(error.xhr.response.error, error.xhr.status, error.xhr.statusText)
                        : error,
                    type: COLLECTIONS.COLLECTION.ROLLUP_SNAPSHOT_ITEM.FETCH.COMPLETED,
                });
            });
    });
};

/**
 * Helper function to generate Observable that makes requests to get all available bags
 * @param collectionId
 * @param merchantId
 * @param collection
 * @returns
 */
const makeBagRequests = (collectionId: string, merchantId: string, collection: any) => {
    const queryParams = {
        merchant_id: merchantId,
        with_snapshot: true,
    };

    const bagObjectRequests = [];

    bagObjectRequests.push({
        url: `${siteConfig.goAPI}/v1/collections/${collectionId}/collection_objects/${ALLOCATION_BAG_ID}?${stringify(
            queryParams
        )}`,
        finishHandler: (acc, collectionObject) => {
            // Mutating response to include `bag_value` in the snapshot since we are not getting this on first load.
            const mutatedCollection = {
                ...acc,
                snapshot: { ...acc.snapshot, [collectionObject.ref.object_id]: collectionObject },
            };

            return mutatedCollection;
        },
    });

    if (collection.target_allocation_bag_ref) {
        bagObjectRequests.push({
            url: `${siteConfig.goAPI}/v1/collections/${collectionId}/collection_objects/${TARGET_BAG_ID}?${stringify(
                queryParams
            )}`,
            finishHandler: (acc, collectionObject) => {
                // Mutating response to include `bag_value` in the snapshot since we are not getting this on first load.
                const mutatedCollection = {
                    ...acc,
                    snapshot: { ...acc.snapshot, [collectionObject.ref.object_id]: collectionObject },
                };

                return mutatedCollection;
            },
        });
    }

    return bagObjectRequests;
};

/**
 * Collect all assortment and them dispatch and integrate action which returns an array of actions indicating that the collection fetching is completed
 */
export const fetchCollectionEpic = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.FETCH.START)
        .concatMap(({ payload }) => {
            const {
                ids: collectionIds,
                collections,
                isRollupMode,
                rollupType,
                failures = 0,
                isServerRollup,
                isCloseoutBrandEnabled,
            } = payload;
            const [baseCollectionId, ...pendingCollectionIds] = collectionIds;
            const nextPayload = {
                collectionId: baseCollectionId,
                collections: collections || [],
                pendingCollectionIds,
                isRollupMode,
                rollupType,
                failures,
                isServerRollup,
                isCloseoutBrandEnabled,
            };

            if (isRollupMode) {
                return Observable.of(nextPayload);
            }

            return Observable.fromPromise(
                dbService.services.getPendingMutation({
                    documentId: baseCollectionId,
                    objectNamespace: ITEMS_NAMESPACE,
                    objectId: ITEMS_ID,
                })
            )
                .concatMap((collectionItemsPendingMutation) => {
                    if (collectionItemsPendingMutation) {
                        store.dispatch(
                            collectionsActions.collectionSetPendingMutation(ITEMS_ID, collectionItemsPendingMutation)
                        );
                    }
                    return Observable.of(nextPayload);
                })
                .takeUntil(action$.ofType(MUTATE_CLEAR))
                .catch(() => {
                    return Observable.of(nextPayload);
                });
        })
        .concatMap(
            ({
                collectionId,
                pendingCollectionIds,
                collections,
                isRollupMode,
                rollupType,
                failures,
                isServerRollup,
                isCloseoutBrandEnabled,
            }) => {
                const merchantId = me.getLastMerchantId();
                if (!merchantId) {
                    return Observable.of({
                        payload: { code: 404 },
                        error: true,
                    });
                }

                if (isServerRollup) {
                    return ajax(
                        `${siteConfig.goAPI}/v1/collections/rollup_snapshots/${collectionId}?${stringify({
                            merchant_id: merchantId,
                            ignore_item_display_preferences: true,
                            with_snapshot: true,
                            without_allocation_dimensions: true,
                            with_collection_status: true,
                        })}`
                    )
                        .flatMap(({ response: { data: rollupSnapshot } }) => {
                            const collectionIds = shouldRecreateSnapshot(rollupSnapshot.status)
                                ? rollupSnapshot.collection_refs.map(({ collection_id }) => collection_id)
                                : [];

                            collectionIds.length &&
                                store.dispatch({
                                    type: COLLECTIONS.COLLECTION.DRIVE_ITEM.CREATE_ROLLUP_SNAPSHOT.INIT,
                                });

                            store.dispatch({
                                type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.START,
                                payload: {
                                    userMerchantId: merchantId,
                                    itemId: rollupSnapshot.id,
                                    rollupSnapshotId: collectionId,
                                    collectionIds,
                                    rollupSnapshotData: rollupSnapshot,
                                },
                            });

                            return Observable.of({
                                collections: [],
                                merchantId,
                                isRollupMode,
                                rollupType,
                                failures,
                                isServerRollup,
                                rollupSnapshot,
                            });
                        })
                        .catch((error) => {
                            return Observable.of({
                                error: true,
                                payload: error.xhr
                                    ? new APIError(error.xhr.response.error, error.xhr.status, error.xhr.statusText)
                                    : error,
                                isRollupMode,
                                rollupType,
                                pendingCollectionIds,
                                collections: collections,
                                failures,
                            });
                        });
                }

                return ajax(
                    `${siteConfig.goAPI}/v1/collections/${collectionId}?with_snapshot=true&merchant_id=${merchantId}`
                )
                    .flatMap(({ response }) => {
                        const { collection } = response;

                        // Hacky, but required as collection snapshot does not hold default item ref.
                        collection.snapshot.root.mutable_map.fields.default_item = {
                            ref: {
                                ...collection.default_item_ref,
                            },
                        };

                        const itemsObjectId = collection.items_ref.object_id;
                        store.dispatch({
                            type: COLLECTIONS.COLLECTION.DRIVE_ITEM.FETCH.START,
                            payload: {
                                userMerchantId: merchantId,
                                itemId: collection.item_id,
                                revision: collection.items_ref.revision,
                            },
                        });

                        const { collection: collectionState } = store.getState();
                        const { pendingMutations } = collectionState;
                        const collectionItemsPendingMutation = pendingMutations.get(itemsObjectId);

                        if (collection.collection_type === CollectionType.BrandStandard && isCloseoutBrandEnabled) {
                            return ajax(
                                `${siteConfig.goAPI}/v1/collections/brand/standard_collection_schema?revision=0`
                            ).map(({ response }) => {
                                collection.snapshot.root.mutable_map.fields.item_display_property = {
                                    struct_value: { ...response.display_property },
                                };

                                if (collectionItemsPendingMutation) {
                                    const objectsQuery = {
                                        sid: collection.sessionId,
                                        revision: collectionItemsPendingMutation.revisionId,
                                        with_snapshot: true,
                                        merchant_id: merchantId,
                                    };
                                    // Load `items` from specific revision if there is pending mutations
                                    return ajax(
                                        `${
                                            siteConfig.goAPI
                                        }/v1/collections/${collectionId}/collection_objects/${itemsObjectId}?${stringify(
                                            objectsQuery
                                        )}`
                                    ).map(({ response: collectionObjectResponse }) => {
                                        const mutatedCollection = {
                                            ...collection,
                                            items_ref: collectionObjectResponse.ref,
                                            snapshot: {
                                                ...collection.snapshot,
                                                items: collectionObjectResponse.object,
                                            },
                                            original: collection,
                                        };
                                        return {
                                            merchantId,
                                            pendingCollectionIds,
                                            collections: collections.concat(mutatedCollection),
                                            isRollupMode,
                                            rollupType,
                                            failures,
                                        };
                                    });
                                }

                                return {
                                    pendingCollectionIds,
                                    collections: collections.concat(collection),
                                    merchantId,
                                    isRollupMode,
                                    rollupType,
                                    failures,
                                };
                            });
                        }

                        // Queue up all the ajax calls to fetch collection objects and then merge them into the single collection
                        let collectionObjectFetchObservables = [];

                        if (collectionItemsPendingMutation) {
                            const objectsQuery = {
                                sid: collection.sessionId,
                                revision: collectionItemsPendingMutation.revisionId,
                                with_snapshot: true,
                                merchant_id: merchantId,
                            };

                            // Load `items` from specific revision if there is pending mutations
                            collectionObjectFetchObservables.push({
                                url: `${
                                    siteConfig.goAPI
                                }/v1/collections/${collectionId}/collection_objects/${itemsObjectId}?${stringify(
                                    objectsQuery
                                )}`,
                                finishHandler: (acc, collectionObject) => {
                                    const mutatedCollection = {
                                        ...acc,
                                        items_ref: collectionObject.ref,
                                        snapshot: {
                                            ...acc.snapshot,
                                            items: collectionObject,
                                        },
                                        original: acc,
                                    };

                                    return mutatedCollection;
                                },
                            });
                        }

                        if (collection.bag_version && +collection.bag_version === 1) {
                            collectionObjectFetchObservables = collectionObjectFetchObservables.concat(
                                makeBagRequests(collectionId, merchantId, collection)
                            );
                        }

                        // Fetch all the collection objects in parallel.
                        if (collectionObjectFetchObservables.length > 0) {
                            return Observable.forkJoin(
                                collectionObjectFetchObservables.map((requestObservable) => {
                                    return ajax(requestObservable.url).map(
                                        (requestResult) => requestResult.response.object
                                    );
                                })
                            ).map((fetchedObjects) => {
                                // `fetchedObjects` is an array of objects returned from the ajax calls in the order they were requested.
                                let mutatedCollection = { ...collection };
                                collectionObjectFetchObservables.forEach(({ finishHandler }, i) => {
                                    mutatedCollection = finishHandler(mutatedCollection, fetchedObjects[i]);
                                });

                                return {
                                    pendingCollectionIds,
                                    collections: collections.concat([mutatedCollection]),
                                    merchantId,
                                    isRollupMode,
                                    rollupType,
                                    failures,
                                };
                            });
                        }

                        const resultObject = {
                            pendingCollectionIds,
                            collections: collections.concat(collection),
                            merchantId,
                            isRollupMode,
                            rollupType,
                            failures,
                        };

                        return Observable.of(resultObject);
                    })
                    .catch((error) => {
                        return Observable.of({
                            error: true,
                            payload: error.xhr
                                ? new APIError(error.xhr.response.error, error.xhr.status, error.xhr.statusText)
                                : error,
                            isRollupMode,
                            rollupType,
                            pendingCollectionIds,
                            collections: collections,
                            failures,
                        });
                    });
            }
        )
        .flatMap((payload) => {
            const isLocalSchemaEnabled = hasLocalSchemasEnabled();
            if (!isLocalSchemaEnabled) {
                return Observable.of(payload);
            }

            const { collections, isServerRollup, rollupSnapshot } = payload as any;
            const currentCollection = collections[0];
            const itemDisplayProperty = isServerRollup
                ? rollupSnapshot?.item_display_property?.struct_value
                : currentCollection?.snapshot.root.mutable_map.fields?.item_display_property?.struct_value;
            const merchantName = itemDisplayProperty?.merchant_name;

            if (!merchantName) {
                return Observable.of(payload);
            }

            const merchantNameNormalized = merchantName
                .toLowerCase()
                .trim()
                .replace(regexForGetAllCharacterNotAlphanumeric, "")
                .replace(/\s+/g, "_");

            return getLocalAssortmentSchema(merchantNameNormalized, payload, isServerRollup);
        })
        .flatMap(
            ({
                pendingCollectionIds,
                collections,
                isRollupMode,
                rollupType,
                failures,
                merchantId,
                error,
                payload,
                isServerRollup,
                rollupSnapshot,
            }) => {
                if (
                    error &&
                    (!isRollupMode ||
                        (isRollupMode &&
                            (payload.code !== 403 || (!pendingCollectionIds?.length && !collections?.length))))
                ) {
                    return Observable.of({
                        error: true,
                        payload: payload,
                        type: COLLECTIONS.COLLECTION.FETCH.COMPLETED,
                    });
                }

                if (rollupSnapshot) {
                    return Observable.fromPromise(deleteAllocationDimensionsFromStoreIfNeeded())
                        .concatMap(() => Observable.fromPromise(readAllocationDimensionsFromStore(rollupSnapshot)))
                        .concatMap(({ hasDimensions, allocationDimensions }) => {
                            if (!hasDimensions || allocationDimensions?.length) {
                                const groups = groupBy(allocationDimensions, "ref.document_id");
                                const allocation_dimensions = Object.keys(groups).map((key) => ({
                                    data: groups[key],
                                }));

                                return Observable.of({
                                    type: COLLECTIONS.COLLECTION.FETCH.INTEGRATE,
                                    payload: {
                                        merchantId,
                                        failures: 0,
                                        isRollupMode,
                                        rollupType,
                                        isServerRollup,
                                        collections: [
                                            buildServerRollupSchema({
                                                ...rollupSnapshot,
                                                allocation_dimensions,
                                            }),
                                        ],
                                    },
                                });
                            }

                            const allocation_dimensions =
                                rollupSnapshot?.collection_refs?.[0].allocation_dimensions || [];
                            const doorDimension = getAllocationDimensionByIndex(
                                allocation_dimensions,
                                AllocationDimensionIndex.Door
                            );
                            const doorDimensionId = doorDimension?.object_id?.replace(
                                new RegExp(`^${ALLOCATION_DIMENSION_ID_PREFIX}`),
                                ""
                            );

                            if (doorDimensionId) {
                                // Rollups: Attributes reflect default merchant values
                                return ajax(
                                    `${siteConfig.goAPI}/v1/collections/merchants/${merchantId}/allocation_dimensions/${doorDimensionId}`
                                )
                                    .map(({ response }) => response)
                                    .flatMap((doorDimension) => {
                                        return Observable.of({
                                            type: COLLECTIONS.COLLECTION.ROLLUP_OBJECT.OBJECT_STREAM.STREAM,
                                            payload: {
                                                rollup_snapshot_id: rollupSnapshot.id,
                                                merchant_id: merchantId,
                                                allocationDimensionsOrder: getAllocationDimensionsOrder(rollupSnapshot),
                                                merchantDoorClassifications: {
                                                    dimensionId: doorDimension.id,
                                                    dimensionValues: doorDimension.dimension_values,
                                                },
                                                snapshotParams: {
                                                    rollupSnapshot,
                                                    merchantId,
                                                    failures: 0,
                                                    isRollupMode,
                                                    rollupType,
                                                    isServerRollup,
                                                },
                                            },
                                        });
                                    })
                                    .catch((error) => {
                                        return Observable.of({
                                            error: true,
                                            payload: error.xhr
                                                ? new APIError(
                                                      error.xhr.response.error,
                                                      error.xhr.status,
                                                      error.xhr.statusText
                                                  )
                                                : error,
                                            isRollupMode,
                                            rollupType,
                                            pendingCollectionIds,
                                            collections: collections,
                                            failures,
                                        });
                                    });
                            } else {
                                return Observable.of({
                                    type: COLLECTIONS.COLLECTION.ROLLUP_OBJECT.OBJECT_STREAM.STREAM,
                                    payload: {
                                        rollup_snapshot_id: rollupSnapshot.id,
                                        merchant_id: merchantId,
                                        allocationDimensionsOrder: getAllocationDimensionsOrder(rollupSnapshot),
                                        snapshotParams: {
                                            rollupSnapshot,
                                            merchantId,
                                            failures: 0,
                                            isRollupMode,
                                            rollupType,
                                            isServerRollup,
                                        },
                                    },
                                });
                            }
                        });
                }

                if (pendingCollectionIds?.length) {
                    return Observable.of({
                        type: COLLECTIONS.COLLECTION.FETCH.START,
                        payload: {
                            ids: pendingCollectionIds,
                            collections,
                            isRollupMode,
                            rollupType,
                            failures: error ? failures + 1 : failures,
                        },
                    });
                }
                return Observable.of({
                    type: COLLECTIONS.COLLECTION.FETCH.INTEGRATE,
                    payload: {
                        collections,
                        merchantId,
                        failures: error ? failures + 1 : failures,
                        isRollupMode,
                        rollupType,
                        isServerRollup,
                    },
                });
            }
        )
        .catch((error) => {
            return Observable.of({
                error: true,
                payload: error,
                type: COLLECTIONS.COLLECTION.FETCH.COMPLETED,
            });
        });
};

/**
 * Returns an array of actions indicating that the collection fetching is completed
 */
export const integrateCollectionsEpic = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.FETCH.INTEGRATE)
        .concatMap(({ payload }) => {
            const { collections, merchantId, failures, isRollupMode, rollupType, isServerRollup } = payload;

            collections.forEach((collection) => {
                const [, assortmentName] = collection.name?.match(removeAssortmentExtRegex) || [];
                collection.name = assortmentName;

                if (rollupType !== RollupType.Server) {
                    get(collection, "snapshot.item_display_preferences.mutable_list.values")?.forEach(
                        (displayPreference) => {
                            displayPreference.struct_value.collectionId = collection.id;
                            displayPreference.struct_value.collectionName = collection.name;
                        }
                    );

                    get(collection, "snapshot.review_display_preferences.mutable_list.values")?.forEach(
                        (displayPreference) => {
                            displayPreference.struct_value.collectionId = collection.id;
                            displayPreference.struct_value.collectionName = collection.name;
                        }
                    );
                }
            });

            const [collection, ...restCollections] = collections;

            if (isRollupMode && rollupType === RollupType.Local) {
                // Set assortment name to base collection
                set(
                    collection,
                    "snapshot.items.mutable_list.values",
                    setAssortmentName(get(collection, "snapshot.items.mutable_list.values"), collection)
                );

                // Aggregate values to base collection and set assortment name
                aggregateDataToBaseCollection(
                    collection,
                    restCollections,
                    "snapshot.items.mutable_list.values",
                    (acc, values, col) => acc.concat(setAssortmentName(values, col))
                );

                // Aggregate collection name into the base collection
                aggregateDataToBaseCollection(collection, restCollections, "name", (acc, value) => `${acc} | ${value}`);

                // Aggregate collections display preferences into the base collection
                aggregateDataToBaseCollection(
                    collection,
                    restCollections,
                    "snapshot.item_display_preferences.mutable_list.values",
                    (acc, value) => {
                        return acc.concat(value);
                    }
                );

                // Add assortment name schema
                addAssortmentNameField(collection);

                // enable all selected dimensions
                enableAllSelectedDimensions(collection, collections);

                aggregateCollectionAllocationDimensions(collection, collections);
            } else if (isServerRollup) {
                // Add assortment name schema
                addAssortmentNameField(collection);
            }

            const items = translateItemsList(
                collection.snapshot.items.mutable_list.values,
                "struct_value.fields.id.string_value"
            );

            const displayPreferences = collection.snapshot.item_display_preferences
                ? translateItemsList(collection.snapshot.item_display_preferences.mutable_list.values)
                : null;
            const merchantDisplayPreferences = collection.snapshot.merchant_item_display_preferences
                ? translateItemsList(collection.snapshot.merchant_item_display_preferences.mutable_list.values)
                : null;
            const reviewDisplayPreferences = collection.snapshot.review_display_preferences
                ? translateItemsList(collection.snapshot.review_display_preferences.mutable_list?.values)
                : null;
            const collectionPoiTags = collection.snapshot.collection_poi_tags
                ? translateItemsList(collection.snapshot.collection_poi_tags.mutable_list?.values)
                : null;
            const deliveryPurchaseOrders = translateItemsList(
                collection.snapshot.delivery_purchase_orders?.mutable_list.values || []
            );
            const { collection: collectionState } = store.getState();
            const { pendingMutations } = collectionState;
            const collectionItemsPendingMutation =
                collection?.items_ref?.object_id && pendingMutations.get(collection.items_ref.object_id);
            const itemsSyncImmediately =
                collection.original && collection.original.items_ref.revision === collection.items_ref.revision;
            const defaultItem = collection.snapshot.default_item?.mutable_map?.fields;

            const allocationBagEntry = collection.snapshot[ALLOCATION_BAG_ID];
            const allocationBag = allocationBagEntry?.mutable_mixed?.objects;

            const targetAllocationBagEntry = collection.snapshot[TARGET_BAG_ID];
            const targetAllocationBag = targetAllocationBagEntry?.mutable_mixed?.objects;

            if (defaultItem && !defaultItem.fields) {
                defaultItem.fields = { struct_value: {} };
            }

            collection.snapshot.root &&
                (collection.snapshot.root.mutable_map.fields.name = {
                    string_value: collection.name,
                });

            const rootFields = {
                ...(collection.snapshot.root?.mutable_map?.fields || {}),
                brand_collection_properties: {
                    struct_value: {
                        brand_id: get(collection, "brand_collection_properties.brand_id"),
                        brand_name: get(collection, "brand_collection_properties.brand_name"),
                        target_merchant_id: get(collection, "brand_collection_properties.target_merchant_id"),
                    },
                },
                bag_version: get(collection, "bag_version"),
            };

            const export_validation_status = collection.snapshot.export_validation_status?.mutable_map?.fields;

            // collection.snapshot.allocation_dimensions is array-like object {"0": {...}, "1": {...}, "3": {...}}
            const allocationDimensionsActions = Object.values<any>(collection.snapshot.allocation_dimensions || {})
                .filter((allocationDimensionSnapshot) => !!allocationDimensionSnapshot.ref)
                .map((allocationDimensionSnapshot) => {
                    return mixedCreate(
                        ALLOCATION_DIMENSIONS_NAMESPACE,
                        allocationDimensionSnapshot.ref,
                        allocationDimensionSnapshot.mutable_mixed.objects
                    );
                });

            const reviewPlanActions = Object.values<any>(collection.snapshot.review_plans || {}).map((planSnapshot) => {
                return mixedCreate(REVIEW_PLANS_NAMESPACE, planSnapshot.ref, planSnapshot.mutable_mixed.objects);
            });

            const deliveryPurchaseOrderActions = collection.snapshot.delivery_purchase_orders
                ? [
                      listCreate(
                          DELIVERY_PURCHASE_ORDERS_NAMESPACE,
                          collection.snapshot.delivery_purchase_orders.ref,
                          deliveryPurchaseOrders
                      ),
                  ]
                : [];

            const targetGroupsActions = collection.snapshot.target_groups
                ? [
                      listCreate(
                          TARGET_GROUPS_NAMESPACE,
                          collection.snapshot.target_groups.ref,
                          collection.snapshot.target_groups.mutable_list.values
                      ),
                  ]
                : [];
            const targetsActions = collection.snapshot.targets
                ? [
                      mixedCreate(
                          TARGETS_NAMESPACE,
                          collection.snapshot.targets.ref,
                          collection.snapshot.targets.mutable_mixed.objects
                      ),
                  ]
                : [];

            const schemaList = fromJS(
                collection.snapshot.root.mutable_map.fields.item_display_property.struct_value.keys
            ) as List<SchemaKeyMap>;

            let mergeActions = [
                initDependentsFieldsLookupMap({ schemaList }),
                mapCreate(ROOT_NAMESPACE, collection.id, rootFields, collection.root_ref),
                listCreate(ITEMS_NAMESPACE, collection.snapshot.items.ref, items),
                ...deliveryPurchaseOrderActions,
                ...allocationDimensionsActions,
                ...reviewPlanActions,
                ...targetGroupsActions,
                ...targetsActions,
                displayPreferences &&
                    listCreate(
                        ITEM_DISPLAY_PREFERENCES_NAMESPACE,
                        collection.snapshot.item_display_preferences.ref,
                        displayPreferences
                    ),
                merchantDisplayPreferences &&
                    listCreate(
                        MERCHANT_ITEM_DISPLAY_PREFERENCES_NAMESPACE,
                        collection.snapshot.merchant_item_display_preferences.ref,
                        merchantDisplayPreferences
                    ),
                reviewDisplayPreferences &&
                    listCreate(
                        REVIEW_DISPLAY_PREFERENCES_NAMESPACE,
                        collection.snapshot.review_display_preferences.ref,
                        reviewDisplayPreferences
                    ),
                collectionPoiTags &&
                    listCreate(
                        COLLECTION_POI_TAGS_NAMESPACE,
                        collection.snapshot.collection_poi_tags.ref,
                        collectionPoiTags
                    ),
                defaultItem &&
                    mapCreate(
                        DEFAULT_ITEM_NAMESPACE,
                        collection.snapshot.default_item.ref.object_id,
                        defaultItem,
                        collection.snapshot.default_item.ref
                    ),
                allocationBag && mixedCreate(ALLOCATION_BAG_NAMESPACE, allocationBagEntry.ref, allocationBag),
                targetAllocationBag &&
                    mixedCreate(TARGET_BAG_NAMESPACE, targetAllocationBagEntry.ref, targetAllocationBag),
                export_validation_status &&
                    mapCreate(
                        EXPORT_VALIDATION_STATUS_NAMESPACE,
                        collection.snapshot.export_validation_status.ref.object_id,
                        export_validation_status,
                        collection.snapshot.export_validation_status.ref
                    ),
                {
                    payload: {
                        collection,
                        items,
                        displayPreferences,
                        merchantId,
                        isRollupMode,
                        rollupType,
                        assortmentsCollectedSize: collections?.length,
                        assortmentsSize: collections?.length + failures,
                        assortmentdIds: collections?.map((it) => it.id),
                    },
                    type: COLLECTIONS.COLLECTION.FETCH.COMPLETED,
                },
                ...(!isRollupMode
                    ? [
                          {
                              type: SUBSCRIPTION.FETCH.START,
                              payload: {
                                  targetType: COLLECTION_FEED_SLUG,
                                  targetFeedId: collection.id,
                                  merchantId: merchantId,
                              },
                          },
                      ]
                    : []),
                collectionItemsPendingMutation
                    ? collectionsActions.collectionApplyPendingMutation(
                          collectionItemsPendingMutation,
                          itemsSyncImmediately
                      )
                    : null,
            ];

            mergeActions = mergeActions.filter((a) => !!a); // compact the array: filter out undefined/nulls
            return mergeActions;
        })
        .catch((error) => {
            return Observable.of({
                error: true,
                payload: error,
                type: COLLECTIONS.COLLECTION.FETCH.COMPLETED,
            });
        });
};

const createMediaAsset = (url: string, fileData: any) => {
    const uploadMediaPromise = superagent.put(url).send(fileData);

    return Observable.fromPromise(uploadMediaPromise);
};

const createCollectionAsset = (
    collectionId: string,
    uploadId: string,
    item: any,
    index: number,
    itemsId: string,
    sessionId: string,
    key: string,
    store,
    merchantId: string
) => {
    const assetData = {
        collection_id: collectionId,
        upload_id: uploadId,
        kind: "IMAGE",
        merchant_id: merchantId,
    };

    const collectionAssetRequest = superagent
        .post(`${siteConfig.goAPI}/v1/collections/${collectionId}/assets?sid=${sessionId}`)
        .send(assetData)
        .withCredentials();

    return Observable.fromPromise(collectionAssetRequest).flatMap((response) => {
        const { mutate } = store.getState();
        const uploadedAssetData = (response as any).body.data[0];
        const fieldKey = key ? key : "additional_image_urls";
        const existingUrls = item[fieldKey] ? item[fieldKey].string_value : null;
        const existingProductUrls = item.image_urls ? item.image_urls.string_value : null;
        let value = { string_value: uploadedAssetData.url };
        if (existingUrls) {
            // we are appending a new url to a comma separated list
            value = { string_value: existingUrls + `,${uploadedAssetData.url}` };
        }

        let mutatedItem = fromJS({});
        let mutatedField;
        if (mutate && mutate.snapshots) {
            // This is in case a set op occurs before receiving the remove op from server
            const currentItems = mutate.snapshots.get(itemsId);
            // This is a source of slowdowns but nessesary evil for now
            mutatedItem = currentItems.find((currentItem) => {
                return currentItem.getIn(["fields", "id", "string_value"]) === item.id.string_value;
            });
            if (mutatedItem) {
                mutatedField = mutatedItem.get("fields").toJS();
            }
        }

        const updatedFields = {
            ...(mutatedField || item),
            [fieldKey]: value,
        };
        const noImageSet = !updatedFields.image_url || !updatedFields.image_url.string_value;
        if (noImageSet && !existingUrls && !existingProductUrls) {
            updatedFields.image_url = { string_value: uploadedAssetData.url };
        }

        const updatedItem = mutatedItem.set("fields", fromJS(updatedFields));

        return [
            collectionsActions.mutateCollectionItem({ itemsId, index, item: updatedItem }),
            {
                payload: updatedItem,
                type: COLLECTIONS.COLLECTION_MEDIA.CREATE.COMPLETED,
            },
        ];
    });
};

export const createCollectionMediaEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION_MEDIA.CREATE.START)
        .map(({ payload }) => payload)
        .mergeMap(({ collectionId, fileData, uploadData, item, index, itemsId, key }) => {
            const { collection } = store.getState();
            const request = {
                body: {
                    ...uploadData,
                },
                method: "POST",
                url: `${siteConfig.goAPI}/v1/uploads`,
            };
            let uploadResponseData;

            return ajax(request)
                .map(({ response }) => {
                    if (!response) {
                        throw new Error();
                    } else {
                        return { data: response.data[0] };
                    }
                })
                .flatMap((uploadObject) => {
                    uploadResponseData = (uploadObject as any).data;
                    const url = (uploadObject as any).data.url;
                    return createMediaAsset(url, fileData);
                })
                .flatMap((response) => {
                    if (uploadResponseData && response && (response as any).status === 200) {
                        return createCollectionAsset(
                            collectionId,
                            uploadResponseData.id,
                            item,
                            index,
                            itemsId,
                            collection.sessionId,
                            key,
                            store,
                            collection.merchantId
                        );
                    } else {
                        return Observable.merge(
                            Observable.of(
                                snackbarAdd({
                                    message: formatMessage(
                                        "There was an error uploading your asset. Please refresh and try again"
                                    ),
                                })
                            )
                        );
                    }
                })
                .catch((error) => {
                    return Observable.merge(
                        Observable.of(
                            snackbarAdd({
                                message: formatMessage(
                                    "There was an error uploading your asset. Please refresh and try again"
                                ),
                            })
                        ),
                        Observable.of({
                            error: true,
                            payload: error,
                            type: COLLECTIONS.COLLECTION_MEDIA.CREATE.COMPLETED,
                        })
                    );
                });
        });

export const copyCollectionEpic = (action$, store: { getState: () => IStore }) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.COPY.START)
        .map(({ payload }) => payload)
        .mergeMap((payload: ICopyProps) => {
            const { collectionId, callback } = payload;
            const state = store.getState();

            const request = {
                body: prepareRequestBodyForCopyCollection(payload, state),
                method: "POST",
                url: `${siteConfig.goAPI}/v1/collections/${collectionId}/copy`,
            };

            return ajax(request)
                .map(({ response }) => {
                    if (!response) {
                        return { result: [] };
                    } else {
                        const records = getRecordsFromSchema(CollectionsSchema);
                        const data = normalizeData(response, CollectionsSchema, records);
                        return { entities: data.entities, result: data.result };
                    }
                })
                .mergeMap(({ entities, result }: any) => {
                    const mergeActions = [
                        updateEntities({
                            collections: (collections = {}) => {
                                return {
                                    ...collections,
                                    ...entities.collections,
                                };
                            },
                        }),
                        snackbarAdd({ message: "Assortment successfully copied" }),
                        collectionsActions.copyCollectionSuccess(result[0]),
                    ];

                    callback && callback(result[0], null);

                    return mergeActions;
                })
                .catch((error) => {
                    callback && callback(null, error?.xhr?.response?.message || error?.message);
                    return Observable.merge(
                        Observable.of(collectionsActions.copyCollectionError(error, true)),
                        Observable.of(
                            snackbarAdd({ message: formatMessage("There was an error copying your assortment") })
                        )
                    );
                });
        });

export const deleteCollectionMediaEpic = (action$) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION_MEDIA.DELETE.START)
        .map(({ payload }) => payload)
        .flatMap(({ item, index, itemsId, key }) => {
            delete item[key];
            const updatedItem = fromJS({
                fields: {
                    ...item,
                },
            });

            return [collectionsActions.mutateCollectionItem({ itemsId, index, item: updatedItem })];
        })
        .catch(() => {
            return Observable.merge(
                Observable.of(snackbarAdd({ message: formatMessage("There was an error deleting your asset") }))
            );
        });
};

export const updateCollectionEpic = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.UPDATE.START)
        .map(({ payload }) => payload)
        .flatMap(({ id, prop, value }) => {
            if (prop === "name") {
                if (!value.get("string_value")) {
                    return [snackbarAdd({ message: formatMessage("Assortment name cannot be blank") })];
                } else {
                    const { collectionItemMerchantId, collectionItemId } = store.getState().collection;
                    const merchantId = collectionItemMerchantId;
                    const assortmentName = value.get("string_value");
                    const renameOnErrorCallBack = value.get("renameOnError");
                    const renameOnSuccessCallBack = value.get("renameOnSuccess");
                    return ajax({
                        body: { name: assortmentName, field_mask: { paths: ["name"] } },
                        method: "PUT",
                        url: `${siteConfig.goAPI}/v1/merchants/${merchantId}/space/items/${collectionItemId}`,
                    })
                        .mergeMap((res) => {
                            renameOnSuccessCallBack?.();
                            return Observable.of({
                                payload: res.response.name,
                                type: COLLECTIONS.COLLECTION.DRIVE_ITEM.RENAME.COMPLETED,
                            });
                        })
                        .catch((e) => {
                            renameOnErrorCallBack?.();
                            return Observable.of(snackbarAdd({ message: e?.xhr?.response?.error || e.message }));
                        });
                }
            }
            return [mapSetOperation(id, prop, value)];
        })
        .catch(() => {
            return Observable.merge(
                Observable.of(snackbarAdd({ message: formatMessage("There was an error updating your assortment") }))
            );
        });
};

export const updateCollectionSettingsEpic = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.UPDATE_COLLECTION_SETTINGS.START)
        .debounce(() => Observable.timer(500))
        .map(({ payload }) => payload)
        .flatMap(
            ({
                assortmentName,
                departmentId,
                marketDate,
                dueDate,
                brandContactEmail,
                brandContactName,
                marketStatus,
                rowCount,
                smuCount,
                totalCost = "0",
                totalRetailValue = "0",
                totalUnits,
                quantityRowsWithUnits,
                totalSized,
                exportCount,
                onSettled,
                departmentName,
                departmentAndNumbers,
                brandName,
            }: SaveAssormentSettingsRequest) => {
                const { collectionItemMerchantId, collectionItemId, merchantId } = store.getState().collection;
                const userItemMerchandId =
                    merchantId && collectionItemMerchantId !== merchantId ? merchantId : collectionItemMerchantId;
                const isOnline = navigator.onLine === true;

                return isOnline
                    ? ajax({
                          body: {
                              name: assortmentName,
                              collection_facet: {
                                  department_id: departmentId,
                                  brand_contact_email: brandContactEmail,
                                  brand_contact_name: brandContactName,
                                  due_date: dueDate ? moment(dueDate).format(dateFormat.YEAR_MONTH_DAY) : "",
                                  market_date: marketDate ? moment(marketDate).format(dateFormat.YEAR_MONTH_DAY) : "",
                                  market_status: marketStatus,
                                  row_count: rowCount,
                                  smu_count: smuCount,
                                  total_cost: totalCost.toString(),
                                  total_retail_value: totalRetailValue.toString(),
                                  total_units: totalUnits,
                                  row_with_units_count: quantityRowsWithUnits,
                                  total_sized: totalSized,
                                  export_count: exportCount,
                                  department_name: departmentName,
                                  department_from_rows: departmentAndNumbers,
                                  brand_name: brandName,
                              },
                              field_mask: {
                                  paths: [
                                      "name",
                                      "collection_facet.department_id",
                                      "collection_facet.brand_contact_email",
                                      "collection_facet.brand_contact_name",
                                      "collection_facet.due_date",
                                      "collection_facet.market_date",
                                      "collection_facet.market_status",
                                      "collection_facet.row_count",
                                      "collection_facet.smu_count",
                                      "collection_facet.total_cost",
                                      "collection_facet.total_retail_value",
                                      "collection_facet.total_units",
                                      "collection_facet.row_with_units_count",
                                      "collection_facet.total_sized",
                                      "collection_facet.export_count",
                                      "collection_facet.department_name",
                                      "collection_facet.department_from_rows",
                                      "collection_facet.brand_name",
                                  ],
                              },
                          },
                          method: "PUT",
                          url: `${siteConfig.goAPI}/v1/merchants/${userItemMerchandId}/space/items/${collectionItemId}`,
                      })
                          .mergeMap((res) => {
                              setTimeout(() => onSettled?.(), 100);
                              return Observable.of({
                                  payload: {
                                      name: res.response.name,
                                      collection_facet: pick(res.response.collection_facet, [
                                          "department_id",
                                          "brand_contact_email",
                                          "brand_contact_name",
                                          "due_date",
                                          "market_date",
                                          "market_status",
                                          "row_count",
                                          "smu_count",
                                          "total_cost",
                                          "total_retail_value",
                                          "total_units",
                                          "row_with_units_count",
                                          "total_sized",
                                          "export_count",
                                          "department_name",
                                          "department_from_rows",
                                          "brand_name",
                                      ]),
                                  },
                                  type: COLLECTIONS.COLLECTION.UPDATE_COLLECTION_SETTINGS.COMPLETED,
                              });
                          })
                          .catch((e) => {
                              const errorMessage = e?.xhr?.response?.error || e.message;

                              onSettled?.(errorMessage);

                              return Observable.of(snackbarAdd({ message: errorMessage }));
                          })
                    : [];
            }
        )
        .catch(() => {
            return Observable.merge(
                Observable.of(snackbarAdd({ message: formatMessage("There was an error updating your assortment") }))
            );
        });
};

export const createCollectionSessionEpic = (action$) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.SESSION.CREATE.START)
        .concatMap(
            ({
                payload: { collectionId, merchantId },
                meta: { pollOnComplete, itemsId, objectId, err, editable = true },
            }) => {
                return ajax({
                    body: {
                        kind: editable ? "READ_WRITE" : "READ_ONLY",
                        merchant_id: merchantId,
                    },
                    method: "POST",
                    url: `${siteConfig.goAPI}/v1/collections/${collectionId}/sessions`,
                })
                    .mergeMap(({ response = {} }) => {
                        if (!response.session_id) {
                            throw new Error("No session id returned");
                        }
                        setValueToLocalStorage(
                            response.collection_id,
                            me._id,
                            merchantId,
                            editable ? NAMESPACE_KEYS.SESSION_READ_WRITE : NAMESPACE_KEYS.SESSION_READ_ONLY,
                            response.session_id
                        );
                        const mergeActions = [
                            collectionsActions.createSessionSuccess(response.collection_id, response.session_id),
                        ];
                        if (pollOnComplete) {
                            if (itemsId) {
                                mergeActions.push(
                                    collectionsActions.subscribeToItemsUpdates(
                                        collectionId,
                                        itemsId,
                                        response.session_id
                                    )
                                );
                            } else if (objectId && err) {
                                mergeActions.push(
                                    collectionsActions.itemsSyncConflict({ collectionId, objectId }, err)
                                );
                            } else {
                                mergeActions.push({
                                    type: COLLECTIONS.COLLECTION.SESSION.UPDATES.POLL,
                                    payload: { collectionId, sessionId: response.session_id },
                                });
                            }
                        }
                        return mergeActions;
                    })
                    .catch((error) => {
                        return Observable.of({
                            error: true,
                            payload: error,
                            meta: {
                                collectionId,
                            },
                            type: COLLECTIONS.COLLECTION.SESSION.CREATE.COMPLETED,
                        });
                    });
            }
        );
};

export const successCollectionSessionEpic = (action$) => {
    return action$.ofType(COLLECTIONS.COLLECTION.SESSION.CREATE.COMPLETED).concatMap((payload) => {
        if ([403, 404].includes(payload.payload?.status)) {
            const { collectionId } = payload.meta || {};

            if (collectionId) {
                return [
                    collectionsActions.cancelCheckForProductUpdates(),
                    collectionsActions.unsubscribeToItemsUpdates(collectionId, ITEMS_ID),
                    collectionsActions.syncErrorThrow(payload.payload),
                ];
            }
        }

        return [
            {
                type: NOOP,
            },
        ];
    });
};

export const subscribeToItemsUpdateEpic = (action$) => {
    return action$.ofType(COLLECTIONS.COLLECTION.ITEMS.UPDATES.SUBSCRIBE).mergeMap(({ payload }) => {
        return [
            { type: COLLECTIONS.COLLECTION.ITEMS.UPDATES.UNSUBSCRIBE },
            // { type: COLLECTIONS.COLLECTION.ITEMS.UPDATES.POLL, payload },
            { type: COLLECTIONS.COLLECTION_STREAM.STREAM, payload },
            // { type: COLLECTIONS.COLLECTION_CHAT.UPDATES.UNSUBSCRIBE },
            // { type: COLLECTIONS.COLLECTION_CHAT.UPDATES.POLL, payload },
            // { type: COLLECTIONS.COLLECTION_BUDGET.UPDATES.UNSUBSCRIBE },
            // { type: COLLECTIONS.COLLECTION_BUDGET.UPDATES.POLL, payload },
            // { type: COLLECTIONS.COLLECTION_BUDGET_ACTUALS.UPDATES.UNSUBSCRIBE },
            // { type: COLLECTIONS.COLLECTION_BUDGET_ACTUALS.UPDATES.POLL, payload },
            // { type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.UPDATES.UNSUBSCRIBE },
            // { type: COLLECTIONS.COLLECTION.ITEMS.ITEMDISPLAYPREFERENCES.UPDATES.POLL, payload },
        ];
    });
};

export const streamChangesEpic = (action$, store) => {
    return action$.ofType(COLLECTIONS.COLLECTION_STREAM.STREAM).switchMap(({ payload: { collectionId, itemsId } }) => {
        return Observable.timer(1) // hack to make this thing keep going
            .switchMap(() => {
                const state = store.getState();
                const { mutate, entities, collection } = state;
                const { committedHEADs } = mutate;
                const collectionSnapshot = mutate.snapshots && mutate.snapshots.get(collectionId);
                const displayPreferencesId: string = collectionSnapshot
                    ? collectionSnapshot.getIn(["item_display_preference_object_id", "ref", "object_id"])
                    : undefined;
                const merchantDisplayPreferencesId: string = collectionSnapshot
                    ? collectionSnapshot.getIn(["merchant_item_display_preference_object_id", "ref", "object_id"])
                    : undefined;
                const committedRootHead = committedHEADs.get(collectionId);

                let lastMessage = null;
                if (entities.chatMessages && entities.chatMessages[`${ROOT_NAMESPACE}-${collectionId}`]) {
                    const chatHistory = entities.chatMessages[`${ROOT_NAMESPACE}-${collectionId}`];
                    lastMessage = chatHistory.messages.get(0);
                }

                const allocationDimensions = getGenericAllocationDimensions(
                    getAllocationDimensions(state, collectionId)
                );
                const { reviewPlanKey } = getReviewPlanFromState(state, collectionId);
                const deliveryPurchaseOrdersId: string = collectionSnapshot
                    ? collectionSnapshot.getIn(["delivery_purchase_orders_ref", "ref", "object_id"])
                    : undefined;
                const reviewDisplayPreferencesId = collectionSnapshot
                    ? collectionSnapshot.getIn(["review_display_preference_object_id", "ref", "object_id"])
                    : undefined;
                const collectionPoiTagsId = collectionSnapshot
                    ? collectionSnapshot.getIn(POI_TAGS_OBJECT_ID_PATH)
                    : undefined;
                const defaultItemObjectId = collectionSnapshot
                    ? collectionSnapshot.getIn(DEFAULT_ITEM_OBJECT_ID_PATH)
                    : undefined;
                const errorLogObjectId = collectionSnapshot
                    ? collectionSnapshot.getIn(EXPORT_VALIDATION_LOG_OBJECT_ID_PATH)
                    : undefined;

                const subscriptionConfig: Array<{ objectId: string; localReference?: string; featureFlag?: string }> = [
                    { objectId: committedRootHead, localReference: collectionId }, // since we grab this by collectionId it needs to be different
                    { objectId: displayPreferencesId },
                    { objectId: merchantDisplayPreferencesId },
                    { objectId: itemsId },
                    ...allocationDimensions.map((allocationDimension) => ({
                        objectId: allocationDimension.id,
                    })),
                    ...(reviewPlanKey ? [{ objectId: reviewPlanKey }] : []),
                    ...(deliveryPurchaseOrdersId ? [{ objectId: deliveryPurchaseOrdersId }] : []),
                    ...(reviewDisplayPreferencesId ? [{ objectId: reviewDisplayPreferencesId }] : []),
                    ...(collectionPoiTagsId ? [{ objectId: collectionPoiTagsId }] : []),
                    ...(defaultItemObjectId ? [{ objectId: defaultItemObjectId }] : []),
                    ...(errorLogObjectId ? [{ objectId: errorLogObjectId }] : []),
                    ...(ALLOCATION_BAG_ID ? [{ objectId: ALLOCATION_BAG_ID }] : []),
                    ...(TARGET_GROUPS_ID ? [{ objectId: TARGET_GROUPS_ID }] : []),
                    ...(TARGETS_ID ? [{ objectId: TARGETS_ID }] : []),
                    ...(TARGET_BAG_ID ? [{ objectId: TARGET_BAG_ID }] : []),
                ];

                // Map config to subscription and received object mapping
                const objectSubscriptions: Array<{ object_id: string; begin_revision: number }> = [];
                const objectMappingToLocalReference: { [object_id: string]: string } = {};
                subscriptionConfig.forEach(({ featureFlag, localReference, objectId }) => {
                    // Check feature flag to see if we can watch these objects
                    if (!featureFlag || siteConfig[featureFlag] === "true") {
                        const localRef = localReference || objectId;
                        const committedHEAD = committedHEADs.get(localRef);
                        if (committedHEAD) {
                            objectSubscriptions.push({
                                object_id: committedHEAD.object_id,
                                begin_revision: parseInt(committedHEAD.revision, 10) + 1,
                            });
                            objectMappingToLocalReference[committedHEAD.object_id] = localRef;
                        }
                    }
                });
                return stream(`${siteConfig.goAPI}/v1/collections/${collectionId}/pull`, {
                    method: "POST",
                    postData: JSON.stringify({
                        // Google Cloud balancer will close open request > 10minutes. So we'll poll for 9.5 minutes.
                        timeout_seconds: 570,
                        document_chat_messages_subscription: {
                            max_message_id: lastMessage ? lastMessage.id : null,
                        },
                        object_subscriptions: objectSubscriptions,
                        merchant_id: collection.merchantId || me.getLastMerchantId(),
                    }),
                    xhrFactory: () => {
                        const req = new XMLHttpRequest();
                        req.withCredentials = true;
                        return req;
                    },
                }).mergeMap((value) => {
                    if (!value.error) {
                        if (value.result.mutations) {
                            const mutationData = value.result.mutations.data || [];
                            const events = mutationData.map((mutation) => {
                                if (!objectMappingToLocalReference[mutation.object_id]) {
                                    throw new Error("Unknown stream object " + mutation.object_id);
                                }
                                return collectionsActions.updateReceived(
                                    collectionId,
                                    objectMappingToLocalReference[mutation.object_id],
                                    [mutation]
                                );
                            });
                            return events;
                        } else if (value.result.chat_messages) {
                            const data = value.result.chat_messages.data;
                            const formattedResponse = {
                                messages: data,
                                key: `${ROOT_NAMESPACE}-${collectionId}`,
                            };
                            const existingEntities = store.getState();
                            const { chatMessages } = existingEntities.entities;
                            if (chatMessages && chatMessages[formattedResponse.key]) {
                                const existingThread = chatMessages[formattedResponse.key];
                                const existingMessages = existingThread.messages.toJS();
                                const updatedMessages = data.concat(existingMessages);
                                formattedResponse.messages = updatedMessages;
                            }

                            const records = getRecordsFromSchema(ChatMessagesSchema);
                            const updatedData = normalizeData(formattedResponse, ChatMessagesSchema, records);

                            const actions = [
                                updateEntities({
                                    chatMessages: (messages = {}) => {
                                        return {
                                            ...messages,
                                            ...updatedData.entities.chatMessages,
                                        };
                                    },
                                }),
                            ];

                            actions.push({
                                payload: {
                                    thread: updatedData.result,
                                    messages: value.result.chat_messages.data,
                                },
                                type: COLLECTIONS.COLLECTION_CHAT.UPDATES.RECEIVED,
                            });

                            return actions;
                        }
                    }
                    return [];
                });
            })
            .repeat()
            .retryWhen((errors) => {
                return errors.delay(10000).do((error) => {
                    sendToSentry(error);
                    if (error.status === 403) {
                        const state = store.getState();
                        return Observable.of(
                            collectionsActions.createSession(collectionId, state.collection.merchantId, {
                                pollOnComplete: true,
                                itemsId,
                            })
                        );
                    }
                    store.dispatch(collectionsActions.refreshPage());
                });
            })
            .catch((error) => {
                sendToSentry(error);
                // if we dont have a good sid, fetch one and try again
                if (error.status === 403) {
                    const state = store.getState();
                    return Observable.of(
                        collectionsActions.createSession(collectionId, state.collection.merchantId, {
                            pollOnComplete: true,
                            itemsId,
                        })
                    );
                }
                // store.dispatch(actions.refreshPage());
                return Observable.empty();
            })
            .takeUntil(action$.ofType(COLLECTIONS.COLLECTION.ITEMS.UPDATES.UNSUBSCRIBE));
    });
};

export const subscribeToChatMessagesEpic = (action$, store) => {
    return action$.ofType(COLLECTIONS.COLLECTION_CHAT.UPDATES.SUBSCRIBE).mergeMap(({ payload }) => {
        return [{ type: COLLECTIONS.COLLECTION_CHAT.UPDATES.POLL, payload }];
    });
};

export const pollForChatMessagesEpic = (action$, store) => {
    let collectionId = "";
    let isPolling = false;
    return action$.ofType(COLLECTIONS.COLLECTION_CHAT.UPDATES.POLL).switchMap((action) => {
        return Observable.timer(1) // hack to make this thing keep going
            .switchMap(() => {
                const { payload } = action;
                collectionId = payload.collectionId;
                const { collection, entities } = store.getState();
                const query: any = {
                    collection_id: collectionId,
                    sid: collection.sessionId,
                    merchant_id: collection.merchantId,
                    limit: 30,
                };

                if (entities.chatMessages && entities.chatMessages[`${ROOT_NAMESPACE}-${collectionId}`]) {
                    const chatHistory = entities.chatMessages[`${ROOT_NAMESPACE}-${collectionId}`];
                    const lastMessage = chatHistory.messages.get(0);
                    query.max_message_id = lastMessage ? lastMessage.id : null;
                    query.wait_for_seconds = 26;
                    isPolling = true;
                } else {
                    isPolling = false;
                }

                return ajax({
                    url: `${siteConfig.goAPI}/v1/collection/${collectionId}/chat_messages?${stringify(query)}`,
                    hideBeforeUnloadWarning: true,
                })
                    .map(({ response }) => {
                        const data = response.data || [];

                        const formattedResponse = {
                            messages: data,
                            key: `${ROOT_NAMESPACE}-${collectionId}`,
                        };
                        const existingEntities = store.getState();
                        const { chatMessages } = existingEntities.entities;
                        const meta = {
                            hasMore: data.length === query.limit,
                        };

                        if (isPolling) {
                            // if I'm polling, the number of messages received does not indicate
                            // if we are on the last page of messages
                            meta.hasMore = existingEntities.collectionChat.hasMore;
                        }
                        let showNewMessagesAlert = true;

                        if (chatMessages && chatMessages[formattedResponse.key]) {
                            const existingThread = chatMessages[formattedResponse.key];
                            const existingMessages = existingThread.messages.toJS();
                            const existingIds = existingMessages.map((msg) => msg.id);
                            const newMessages = data.filter((msg) => !existingIds.includes(msg.id));
                            // Awkward, but if user that added a message already has it locally, so
                            // don't need to re-add
                            const notMyMessages = newMessages.filter((msg) => msg.identity !== me._id);
                            showNewMessagesAlert = notMyMessages.length > 0;
                            existingMessages.unshift(newMessages);
                            const updatedMessages = newMessages.concat(existingMessages);
                            formattedResponse.messages = updatedMessages;
                        }

                        const records = getRecordsFromSchema(ChatMessagesSchema);
                        const updatedData = normalizeData(formattedResponse, ChatMessagesSchema, records);

                        return {
                            normalizedEntities: updatedData.entities,
                            result: updatedData.result,
                            data,
                            meta,
                            showNewMessagesAlert,
                        };
                    })
                    .mergeMap((normalizedData) => {
                        const { normalizedEntities, result, data, meta, showNewMessagesAlert } = normalizedData as any;
                        let actions = [
                            updateEntities({
                                chatMessages: (messages = {}) => {
                                    return {
                                        ...messages,
                                        ...normalizedEntities.chatMessages,
                                    };
                                },
                            }),
                            // {
                            //     payload: [result],
                            //     type: COLLECTIONS.COLLECTION_CHAT.FETCH_MESSAGES.COMPLETED,
                            //     meta,
                            // },
                        ];
                        if (isPolling && !data.length) {
                            actions = [];
                        }

                        if (isPolling && data.length) {
                            actions.push({
                                payload: {
                                    thread: result,
                                    messages: data,
                                },
                                type: COLLECTIONS.COLLECTION_CHAT.UPDATES.RECEIVED,
                                meta,
                            });
                        }

                        return actions;
                    });
            })
            .repeat()
            .retryWhen((errors) => {
                return errors
                    .map((error) => {
                        if (error.status >= 400 && error.status < 500) {
                            throw error;
                        }
                        return Observable.empty();
                    })
                    .delay(3000); // if error, give it time
            })
            .catch((error) => {
                return Observable.empty();
            })
            .takeUntil(action$.ofType(COLLECTIONS.COLLECTION_CHAT.UPDATES.UNSUBSCRIBE));
    });
};

export const receivedUpdatesEpic = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.UPDATES.RECEIVED)
        .filter(({ payload: { data } }) => !!data.length)
        .map(({ payload }) => payload)
        .mergeMap(({ objectId, data }) => {
            const state = store.getState();
            const { mutate, collection } = state;
            const { sentMutations, committedSnapshots, committedHEADs, uncommittedMutations } = mutate;
            let sentMutation = sentMutations.get(objectId);
            let committedSnapshot = committedSnapshots.get(objectId);
            let uncommittedMutationsForEntity = uncommittedMutations.get(objectId) || List();
            const committedHEAD = committedHEADs.get(objectId);
            const actions = [];
            let revision = parseInt(committedHEAD.revision, 10);
            let outOfOrderMutationDetected = false;
            let hasMyChanges = false;
            let requestId = undefined;

            const committedCommandsThatAreNotMine = [];
            data.forEach((mutation) => {
                const mutationRevision = parseInt(mutation.revision, 10);
                if (!isNaN(mutationRevision) && mutationRevision === revision + 1) {
                    revision = mutationRevision;
                    let isMine = false;
                    // See if its this tab's request
                    if (
                        sentMutation &&
                        mutation.session_id === collection.sessionId &&
                        sentMutation.requestId === mutation.session_request_id &&
                        parseInt(sentMutation.revision, 10) === parseInt(mutation.revision, 10)
                    ) {
                        // found, remove from uncommittedMutations
                        sentMutation = undefined;
                        hasMyChanges = true;
                        isMine = true;
                        requestId = mutation.session_request_id;
                    }

                    mutation.operations.forEach((operation) => {
                        if (operation && operation.mutable_list_operation) {
                            Object.keys(operation.mutable_list_operation).forEach((command) => {
                                if (command && VALID_OPERATIONS.includes(command)) {
                                    const params = operation.mutable_list_operation[command];
                                    if (params.value) {
                                        params.value = fromJS(params.value.struct_value);
                                    }
                                    const operationsToCommit = {
                                        mutableType: MutableType.List,
                                        objectId: mutation.object_id,
                                        operations: [
                                            {
                                                ...params,
                                                operation: command,
                                            },
                                        ],
                                    };
                                    if (!isMine) {
                                        committedCommandsThatAreNotMine.push({
                                            ...params,
                                            mutableType: MutableType.List,
                                            objectId: mutation.object_id,
                                            operation: command,
                                        });
                                    }
                                    committedSnapshot = mutateSnapshot(committedSnapshot, operationsToCommit);
                                }
                            });
                        }

                        if (operation && operation.mutable_map_operation) {
                            Object.keys(operation.mutable_map_operation).forEach((command) => {
                                if (command && VALID_OPERATIONS.includes(command)) {
                                    const params = operation.mutable_map_operation[command];
                                    if (params.value) {
                                        params.value = fromJS(params.value);
                                    }
                                    const operationsToCommit = {
                                        mutableType: MutableType.Map,
                                        objectId: mutation.object_id,
                                        operations: [
                                            {
                                                ...params,
                                                operation: command,
                                            },
                                        ],
                                    };
                                    if (!isMine) {
                                        committedCommandsThatAreNotMine.push({
                                            ...params,
                                            mutableType: MutableType.Map,
                                            objectId: mutation.object_id,
                                            operation: command,
                                        });
                                    }
                                    committedSnapshot = mutateSnapshot(committedSnapshot, operationsToCommit);
                                }
                            });
                        }

                        if (operation && operation.mutable_mixed_operation) {
                            Object.keys(operation.mutable_mixed_operation).forEach((command) => {
                                if (command && VALID_OPERATIONS.includes(command)) {
                                    const params = operation.mutable_mixed_operation[command];
                                    if (params.value) {
                                        params.value = fromJS(params.value);
                                    }

                                    let mutableType;
                                    if (command.match(/list_/i)) {
                                        mutableType = MutableType.List;
                                    } else if (command.match(/map_/i)) {
                                        mutableType = MutableType.Map;
                                    }
                                    const operationType = command.replace(/list_|map_/i, "");
                                    const operationsToCommit = {
                                        mutableType,
                                        objectId: mutation.object_id,
                                        operations: [
                                            {
                                                ...params,
                                                // Don't get this confused with mutation.object_id (eg: 000004)
                                                // operation.mutable_mixed_operation.object_id is key to reference inner object
                                                childKey: operation.mutable_mixed_operation.object_id,
                                                operation: operationType,
                                            },
                                        ],
                                    };
                                    if (!isMine) {
                                        committedCommandsThatAreNotMine.push({
                                            ...params,
                                            mutableType,
                                            objectId: mutation.object_id,
                                            // Don't get this confused with mutation.object_id (eg: 000004)
                                            // operation.mutable_mixed_operation.object_id is key to reference inner object
                                            childKey: operation.mutable_mixed_operation.object_id,
                                            operation: operationType,
                                        });
                                    }
                                    committedSnapshot = mutateSnapshot(committedSnapshot, operationsToCommit);
                                }
                            });
                        }
                    });
                } else if (mutationRevision > revision) {
                    // We need to wait for updates
                    outOfOrderMutationDetected = true;
                }
                // else we saw it already, ignore
            });

            if (!outOfOrderMutationDetected) {
                // if we have something pending, assuming it 409ed or 500, add it back to the end
                if (sentMutation) {
                    uncommittedMutationsForEntity = sentMutation.mutations.concat(uncommittedMutationsForEntity);
                }

                // rebuild
                const commandsToTransform = [];
                uncommittedMutationsForEntity.forEach((mutation) => {
                    mutation.operations.forEach((operation) => {
                        commandsToTransform.push({
                            objectId,
                            mutableType: mutation.mutableType,
                            ...operation,
                        });
                    });
                });

                let tempSnapshot = committedSnapshot;
                const uncommittedRightTransformMutations = [];
                if ([ALLOCATION_BAG_ID, TARGET_BAG_ID].includes(objectId)) {
                    // `getOperationTransforms` is recursive operation and allocation bag mutations are way too many, it can cause stack max operation.
                    commandsToTransform.forEach((mutation) => {
                        const { objectId, mutableType, ...rest } = mutation;
                        mutation = {
                            objectId,
                            mutableType,
                            operations: [rest],
                        };
                        tempSnapshot = mutateSnapshot(tempSnapshot, mutation);
                        uncommittedRightTransformMutations.push(mutation);
                    });
                } else {
                    // Specifically Mutable Mixed, nested object can be either LIST or MAP. `getOperationTransforms` is not written to handle mixed objects.
                    // So we will run `getOperationTransforms` per type
                    const rightTransformOperations = Object.values(MutableType).reduce((acc, mutableType) => {
                        const filteredCommandsToTransform = commandsToTransform.filter(
                            (command) => command.objectId === objectId && command.mutableType === mutableType
                        );
                        const filteredCommandsThatAreNotMine = committedCommandsThatAreNotMine.filter(
                            (command) => command.objectId === objectId && command.mutableType === mutableType
                        );

                        const { rightTransform } = getOperationTransforms(
                            objectId,
                            filteredCommandsToTransform,
                            filteredCommandsThatAreNotMine
                        );
                        return acc.concat(rightTransform);
                    }, []);

                    rightTransformOperations.forEach((mutation) => {
                        const { objectId, mutableType, ...rest } = mutation;
                        const operation = { ...rest };
                        coerceOperationTransform(operation, mutation);

                        mutation = {
                            objectId,
                            mutableType,
                            operations: [operation],
                        };
                        tempSnapshot = mutateSnapshot(tempSnapshot, mutation);
                        uncommittedRightTransformMutations.push(mutation);
                    });
                }

                const batchMaxSize = getMutationBatchSizeByObjectId(objectId);
                const objectMutations = batchMutations(objectId, uncommittedRightTransformMutations, batchMaxSize);
                const recalculateTotals = shouldRecalculateTotals(objectId, collection.sessionId, data);

                actions.push(
                    updateSnapshotFromCommitted({
                        revision,
                        committedHEADRevision: revision,
                        snapshot: tempSnapshot,
                        uncommittedMutationsForEntity: List(objectMutations),
                        committedSnapshot,
                        objectId,
                        sentMutation: undefined,
                        committedHEAD,
                        hasMyChanges,
                        recalculateTotals,
                        requestId,
                    })
                );
            }

            return actions;
        });
};

export const setSessionCellFocusEpic = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.SESSION.FOCUS.SET)
        .map(({ payload }) => {
            const { sessionId, merchantId } = store.getState().collection;
            return { ...payload, sessionId, merchantId };
        })
        .filter(({ collectionId, itemsId, sessionId }) => !!collectionId && !!itemsId && !!sessionId)
        .switchMap(({ collectionId, itemsId, sessionId, field, merchantId }) => {
            return ajax({
                url: `${siteConfig.goAPI}/v1/collections/${collectionId}/sessions/${sessionId}/focus_ons`,
                method: "POST",
                body: {
                    merchant_id: merchantId,
                    focus_ons: [
                        {
                            object_id: itemsId,
                            object_field: field,
                        },
                    ],
                },
                hideBeforeUnloadWarning: true,
            }).catch(() => {
                return Observable.empty();
            });
        })
        .mergeMap(() => []);
};

export const subscribeToSessionUpdatesEpic = (action$, store) => {
    return action$.ofType(COLLECTIONS.COLLECTION.SESSION.UPDATES.SUBSCRIBE).mergeMap(({ payload }) => {
        return [
            { type: COLLECTIONS.COLLECTION.SESSION.UPDATES.UNSUBSCRIBE },
            { type: COLLECTIONS.COLLECTION.SESSION.UPDATES.POLL, payload },
        ];
    });
};

export const pollForSessionUpdatesEpic = (action$, store) => {
    return action$.ofType(COLLECTIONS.COLLECTION.SESSION.UPDATES.POLL).switchMap((action) => {
        let isNew = true;
        let lastTimestamp;
        return Observable.timer(250) // hack to make this thing keep going
            .switchMap(() => {
                const { payload } = action;
                const { collectionId } = payload;
                const { collection } = store.getState();
                const query = {
                    sid: collection.sessionId,
                    wait_for_seconds: isNew ? undefined : 26,
                    min_updated_at_ms: lastTimestamp,
                    ignore_own_sessions: true,
                    merchant_id: collection.merchantId,
                };
                return ajax({
                    url: `${siteConfig.goAPI}/v1/collections/${collectionId}/sessions?${stringify(query)}`,
                    hideBeforeUnloadWarning: true,
                }).mergeMap(({ response = {} }) => {
                    let { activeUserSessions } = collection;
                    const remainingUserColors = USER_COLORS.slice();
                    let userColorIndex = 0;
                    let hasChanges = false;
                    isNew = false;
                    lastTimestamp = response.response_at_ms;
                    const fiveMinutesAgo = Number(lastTimestamp) - 300000;
                    // Prune out old sessions
                    activeUserSessions.forEach((value, key) => {
                        if (Number(value.getIn(["sessions", 0, "updated_at_ms"])) - fiveMinutesAgo < 0) {
                            activeUserSessions = activeUserSessions.delete(key);
                            hasChanges = true;
                        } else {
                            const color = value.get("color");
                            const index = remainingUserColors.indexOf(color);
                            if (index !== -1) {
                                remainingUserColors.splice(index, 1);
                            }
                        }
                    });
                    // add new ones
                    if (response.identity_sessions) {
                        Object.keys(response.identity_sessions).forEach((key) => {
                            const activeSession = activeUserSessions.get(key);
                            if (activeSession) {
                                // dont override the color key
                                activeUserSessions = activeUserSessions.setIn(
                                    [key, "sessions"],
                                    fromJS(response.identity_sessions[key].sessions)
                                );
                            } else {
                                const session = response.identity_sessions[key];
                                // Set the user color, if there isnt anymore make up one
                                // tslint:disable-next-line
                                session.color =
                                    remainingUserColors[userColorIndex] ||
                                    "#" + (((1 << 24) * Math.random()) | 0).toString(16);
                                activeUserSessions = activeUserSessions.set(key, fromJS(session));
                                userColorIndex = userColorIndex + 1;
                            }
                            hasChanges = true;
                        });
                    }

                    if (hasChanges) {
                        let focusOnCellMap = Map<string, any>();
                        activeUserSessions.forEach((value) => {
                            const field = value.getIn(["sessions", 0, "focus_ons", 0, "object_field"]) || ""; // new sessions come with empty focus_ons array
                            focusOnCellMap = focusOnCellMap.set(field, value);
                        });
                        return [
                            collectionsActions.sessionUpdateReceived(collectionId, activeUserSessions, focusOnCellMap),
                        ];
                    }
                    return [];
                });
            })
            .repeat()
            .retryWhen((errors) => {
                return errors
                    .map((error) => {
                        if (error.status === 403) {
                            throw error;
                        }
                        return Observable.empty();
                    })
                    .delay(3000); // if error, give it time
            })
            .catch((error) => {
                if (error.status === 403) {
                    const { payload } = action;
                    const { collectionId } = payload;
                    const { collection } = store.getState();
                    return Observable.of(
                        collectionsActions.createSession(collectionId, collection.merchantId, { pollOnComplete: true })
                    );
                }
                return Observable.empty();
            })
            .takeUntil(action$.ofType(COLLECTIONS.COLLECTION.SESSION.UPDATES.UNSUBSCRIBE));
    });
};

export const exportCollectionEpic = (action$, store: { getState: () => IStore }) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.EXPORT.CREATE.START)
        .map(({ payload }) => payload)
        .mergeMap((payload: IExportParams) => {
            const {
                merchantName,
                collectionId,
                showExportToMerchant = false,
                rollupSnapshotId,
                numberOfRows,
                isUpcExporting,
            } = payload;
            const {
                collection,
                routing: { locationBeforeTransitions },
            } = store.getState();
            const { merchantId, sessionId }: ICollectionState = collection;
            const query = { sid: sessionId };
            let body;
            let url;
            const allocationDimensions = getAllocationDimensions(store.getState(), collectionId);
            const doors = getDoors(store.getState(), collectionId);
            const analytics = (global as any).analytics as any;
            let visibleColumnsList = payload.visibleColumnsList;
            if (isUpcExporting) {
                visibleColumnsList = getColumnsForExportUpcs(visibleColumnsList, collection.merchantIdentifierFields);
            }

            if (rollupSnapshotId) {
                // Export rollup
                trackEventExportRollup({ merchantName, numberOfRows, analytics });
                body = prepareRequestBodyForExportRollup({
                    queryFilter: payload.queryFilter,
                    visibleColumnsList: payload.visibleColumnsList,
                    selectedAllocationDimensions: payload.selectedAllocationDimensions,
                    merchantId,
                    allocationDimensions,
                    locationBeforeTransitions,
                    doors,
                });
                url = `${siteConfig.goAPI}/v1/collections/rollup_snapshots/${rollupSnapshotId}/exports`;
            } else {
                trackEventExportAssortment({
                    merchantName,
                    layout: payload.layout,
                    unitType: payload.unitType,
                    selectedAllocationDimensions: payload.selectedAllocationDimensions,
                    horizontalAllocationDimensions: payload.horizontalAllocationDimensions,
                    showExportToMerchant,
                    view: payload.view,
                    accountType: me.account_type,
                    allocationDimensions,
                    analytics,
                });
                body = prepareRequestBodyForExportAssortment({
                    type: payload.type,
                    visibleColumnsList,
                    visibleRowsList: payload.visibleRowsList,
                    exportFileName: payload.exportFileName,
                    layout: payload.layout,
                    withUnits: payload.withUnits,
                    withNotes: payload.withNotes,
                    unitType: payload.unitType,
                    selectedAllocationDimensions: payload.selectedAllocationDimensions,
                    horizontalAllocationDimensions: payload.horizontalAllocationDimensions,
                    rowOrder: payload.rowOrder,
                    actionMessage: payload.actionMessage,
                    includeAssortmentId: payload.includeAssortmentId,
                    merchantId,
                    allocationDimensions,
                    locationBeforeTransitions,
                    doors,
                    isUpcExporting,
                });
                url = `${siteConfig.goAPI}/v1/collections/${collectionId}/exports?${stringify(query)}`;
            }

            return ajax({
                body,
                method: "POST",
                url,
            })
                .mergeMap(({ response }) => {
                    if (rollupSnapshotId) {
                        // Rollup
                        const { rollup_export } = response;
                        return Observable.of(
                            collectionsActions.pollCollectionExport(collectionId, rollup_export.id, rollupSnapshotId)
                        );
                    }

                    // Assortment
                    const { collection_export } = response;

                    if (showExportToMerchant) {
                        const {
                            driveItem: { capabilities },
                        } = collection;

                        return Observable.merge(
                            Observable.of(snackbarAdd({ message: `Exported to ${merchantName} successfully!` })),
                            Observable.of(collectionsActions.pollCollectionExport(collectionId, collection_export.id)),
                            capabilities?.can_edit &&
                                Observable.of(
                                    ...updateExportCountInCollectionFacet({
                                        driveItem: collection?.driveItem,
                                        doorTotals: collection?.doorTotals,
                                        shouldIncreaseExportCount: true,
                                        shouldSendCollectionReports: true,
                                    })
                                )
                        );
                    }

                    return Observable.of(collectionsActions.pollCollectionExport(collectionId, collection_export.id));
                })
                .catch((error) => {
                    return Observable.merge(
                        Observable.of(snackbarAdd({ message: `Error: ${error?.message}` })),
                        Observable.of(collectionsActions.createCollectionExportError(error))
                    );
                });
        });

export const exportNordstromPushEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.NORDSTROM.CREATE.START)
        .map(({ payload }) => payload)
        .mergeMap(({ collectionId, type = "ACTION", rowIds, exportName, merchantName, view, accountType }) => {
            const { collection } = store.getState();
            const query = { sid: collection.sessionId };
            const body: any = {
                type,
                action_message: "nordstrom_push",
                merchant_id: collection.merchantId,
            };

            if (rowIds) {
                const convertedRows = rowIds.map((rowId) => {
                    return { string_value: rowId };
                });
                body.row_filter = {
                    in: {
                        field: "id",
                        values: convertedRows,
                    },
                };
            }

            if (exportName) {
                body.export_name = exportName;
            }

            const analytics = (global as any).analytics as any;
            analytics.track(EXPORT_ASSORTMENT_TO_MERCHANT, {
                merchantName,
                view,
                accountType: accountType,
            });

            return ajax({
                body,
                method: "POST",
                url: `${siteConfig.goAPI}/v1/collections/${collectionId}/exports?${stringify(query)}`,
            })
                .map(({ response }) => response)
                .flatMap(() => {
                    const actions = [];
                    actions.push(
                        ...updateExportCountInCollectionFacet({
                            driveItem: collection.driveItem,
                            doorTotals: collection.doorTotals,
                            shouldIncreaseExportCount: true,
                            shouldSendCollectionReports: true,
                        })
                    );

                    actions.push(
                        ...[
                            snackbarAdd({ message: formatMessage("Assortment sent") }),
                            {
                                payload: {},
                                type: COLLECTIONS.COLLECTION.NORDSTROM.CREATE.COMPLETED,
                            },
                        ]
                    );
                    return actions;
                })
                .catch(() => {
                    return Observable.of(
                        snackbarAdd({ message: formatMessage("There was an error communicating with Nordstrom") })
                    );
                });
        });

export const pollExportCollectionEpic = (action$, store) =>
    action$.ofType(COLLECTIONS.COLLECTION.EXPORT.POLL).switchMap((action) => {
        const { payload } = action;

        const { collectionId, exportId, rollupSnapshotId } = payload;
        const { collection } = store.getState();

        const query = { sid: collection.sessionId, merchant_id: collection.merchantId };
        const url = rollupSnapshotId
            ? `${siteConfig.goAPI}/v1/collections/rollup_snapshots/${rollupSnapshotId}/exports/${exportId}?${stringify(
                  query
              )}`
            : `${siteConfig.goAPI}/v1/collections/${collectionId}/exports/${exportId}?${stringify(query)}`;

        return Observable.timer(0, 5000)
            .mergeMap(() =>
                ajax({
                    url,
                })
                    .mergeMap(({ response }) => {
                        let exportResponse = response.collection_export;

                        if (rollupSnapshotId) {
                            exportResponse = response.rollup_export;
                        }
                        switch (exportResponse.status) {
                            case EXPORT_STATUS.FINISHED:
                                return Observable.of(
                                    collectionsActions.receivedCollectionExport(fromJS(exportResponse))
                                );
                            case EXPORT_STATUS.CREATED:
                                if (collection.collectionExport.get("status") !== EXPORT_STATUS.CREATED) {
                                    return Observable.of(
                                        collectionsActions.createCollectionExportSuccess(fromJS(exportResponse))
                                    );
                                } else {
                                    return [];
                                }
                            // TODO: Future error handling
                            case EXPORT_STATUS.FAILED:
                            case EXPORT_STATUS.DEADLINE_EXCEEDED:
                            case EXPORT_STATUS.CANCELED:
                            default:
                                return [];
                        }
                    })
                    .catch((error) => {
                        return Observable.of(collectionsActions.createCollectionExportError(error));
                    })
            )
            .takeUntil(action$.ofType(COLLECTIONS.COLLECTION.EXPORT.RECEIVED))
            .takeUntil(action$.ofType(COLLECTIONS.COLLECTION.EXPORT.CLEAR));
    });

export const heartbeatCheck = (action$, store) =>
    action$.ofType(COLLECTIONS.COLLECTION.HEARTBEAT).mergeMap(() => {
        app.trigger(COLLECTIONS.COLLECTION.HEARTBEAT);
        return [];
    });

export const gridXlsExport = (action$, state) => {
    return action$.ofType(COLLECTIONS.COLLECTION.GRID.XLS_EXPORT).switchMap(({ payload }) => {
        const { collection: collectionState } = state.getState();
        const { collection, assortmentIds } = payload;
        const itemDisplayProperty = collection
            ? collection.getIn(CollectionKeys.ITEM_DISPLAY_PROPERTY.KEYS)
            : undefined;
        const itemDisplayPropertyJS = itemDisplayProperty.toJS();
        const headersToSkip = itemDisplayPropertyJS
            .filter((entry) => entry && entry.csv_view && entry.csv_view.header_name === "")
            .map((entry) => entry.field_name);

        if (collection && collectionState.gridApi && collectionState.columnApi) {
            const fileName =
                assortmentIds?.length > 1
                    ? // example filename for rollups: "Rollup 2020-05-14 012014 - 5 Assortments"
                      `Rollup ${new Date().toISOString().slice(0, 19).replace("T", " ").replace(/:/g, "")} - ${
                          assortmentIds.length
                      } Assortments`
                    : // name of assortment as filename
                      nameExtRemover(collectionState?.driveItem?.name, ItemKind.CollectionDocument);
            const columnKeys = (collectionState.columnApi as ColumnApi)
                .getAllColumns()
                .filter((column) => column.getColId() !== IMAGE_URL)
                .map((column) => column.getColId());
            collectionState.gridApi.exportDataAsExcel({
                sheetName: formatMessage("All Brands"),
                fileName,
                columnKeys,
                columnGroups: true,
                processHeaderCallback: ({ column }) => {
                    return headersToSkip.includes(column.colId) ? "" : column.colDef.headerName;
                },
                processCellCallback: ({ column, value }) => {
                    return column.colDef.cellClass === EXCEL_STYLES.PERCENT_CELL_CLASS ? value / 100 : value;
                },
            });
        }

        return [];
    });
};

const SIZE_PACKS_LIMIT = 1000;
const SIZE_PACKS_LIMIT_WITH_PAGINATION = 100;
const fullyFetchedBrands = [];
export const getSizePacksForBrand = (action$, store$) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.SIZE_PACKS.FETCH.START)
        .map(({ payload }) => payload)
        .mergeMap(({ brand, includeNormalized, lastFetchedId }) => {
            const { collection } = store$.getState();
            const { sizePacks } = collection;

            if (fullyFetchedBrands.includes(brand) || (sizePacks[brand] && !lastFetchedId)) {
                return [sizePacksFetchComplete()];
            }

            const queryString = `__brand=${brand}&includeInactive=true&__limit=${
                lastFetchedId || !includeNormalized ? SIZE_PACKS_LIMIT_WITH_PAGINATION : SIZE_PACKS_LIMIT
            }${includeNormalized ? "&includeNormalizedSizes=true" : ""}${
                lastFetchedId ? `&__last_id=${lastFetchedId}` : ""
            }`;
            return (
                ajax({
                    method: "GET",
                    url: `${siteConfig.api}/api/v3.0/items/packs?${queryString}`,
                })
                    .flatMap(({ response }) => {
                        if (response.length === 0) {
                            fullyFetchedBrands.push(brand);
                            return [sizePacksFetchComplete()];
                        }
                        return [
                            sizePacksFetchComplete(
                                response.reduce(
                                    (
                                        acc,
                                        {
                                            _id: id,
                                            name,
                                            brand,
                                            brand_identifier: brandIdentifier,
                                            pack_type: packType,
                                            pack_units,
                                            active,
                                            upc,
                                        }
                                    ) => {
                                        if (!acc[brand]) {
                                            acc[brand] = {};
                                        }
                                        acc[brand][id] = {
                                            id,
                                            name,
                                            brand,
                                            brandIdentifier,
                                            packType,
                                            packUnits: pack_units.map(({ _id: id, key, normalized_key, ...rest }) => ({
                                                id,
                                                normalized_key: normalized_key ? normalized_key : key,
                                                ...rest,
                                            })),
                                            packUPC: upc,
                                            active,
                                        };

                                        return acc;
                                    },
                                    { [brand]: sizePacks[brand] ? { ...sizePacks[brand] } : {} }
                                )
                            ),
                        ];
                    })
                    .catch((error) => {
                        if (error.status >= 500) {
                            return Observable.of(sizePacksFetchComplete({ [brand]: {} }, true));
                        }
                        return Observable.of(sizePacksFetchComplete(undefined, true));
                    }) ?? []
            );
        });
};

const LOG_ENTRIES_TYPE = "JSON_INGESTION_FTP";
const EXPORT_LOGS_FETCH_LIMIT = 50;
export const fetchCollectionExportLogs = (action$, store$) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.EXPORT.LOGS.FETCH.START)
        .map(({ payload }) => payload)
        .flatMap(({ collectionId, refetch }) => {
            const { collection } = store$.getState();

            if (!collection.hasMoreExportLogs && !refetch) {
                return [];
            }

            const lastFetchedId = (collection.collectionExportLogs as List<any>).last()?.get("id");
            const queryStringParams = {
                sid: collection.sessionId,
            };
            const bodyParams = {
                merchant_id: collection.merchantId,
                limit: EXPORT_LOGS_FETCH_LIMIT,
                filter: {
                    eq: {
                        field: "type",
                        value: { string_value: LOG_ENTRIES_TYPE },
                    },
                },
            };

            if (!refetch && lastFetchedId) {
                (bodyParams as any).open = lastFetchedId;
            }

            return ajax({
                url: `${siteConfig.goAPI}/v1/collections/${collectionId}/exports/list?${stringify(queryStringParams)}`,
                method: "POST",
                body: bodyParams,
            })
                .flatMap((req) => {
                    const { data } = req.response as { data: any[] };

                    const shouldAppend = !refetch;

                    const immutableData = fromJS(data);
                    if (data.length < EXPORT_LOGS_FETCH_LIMIT) {
                        return [completeFetchingExportLogs(immutableData, false, shouldAppend)];
                    }

                    return [completeFetchingExportLogs(immutableData, true, shouldAppend)];
                })
                .catch(() => Observable.of(completeFetchingExportLogs(List(), false, false)));
        });
};

const getActionsForExportItems = ({
    collectionId,
    dimensionValues,
    exportOptions,
    exportStatusTime,
    exportType,
    itemIds,
    state,
    shouldIncreaseExportCount,
    shouldSendCollectionReports,
    enableToCollectReports,
    doorTotals,
    driveItem,
}: {
    collectionId: string;
    dimensionValues: { [k: string]: string[] };
    itemIds: string[];
    exportType: string;
    state: IStore;
    exportOptions: { item: { name: string; active: boolean }; po: { name: string; active: boolean } };
    exportStatusTime: string;
    shouldIncreaseExportCount: boolean;
    shouldSendCollectionReports: boolean;
    enableToCollectReports: boolean;
    driveItem: nuorder.folder.v1.Item;
    doorTotals: IDoorTotals;
}) => {
    const actions = [];
    const doubleExportType = `${exportOptions.item.name}, ${exportOptions.po.name}`;
    const collection = state.mutate.snapshots.get(collectionId);
    const itemsId = collection.getIn(["items", "ref", "object_id"]);
    const items = getCollectionItems(state, collectionId) as List<Map<string, any>>;

    if (!items.size) {
        return [];
    }

    const allocationBag = getCollectionAllocationBag(state, collectionId);
    const isLegacyBag = !allocationBag;
    const allocationDimensions = getAllocationDimensionsBySubtype(state, collectionId, AllocationDimensionKind.Generic);
    const deliveriesId = getAllocationDimensionByIndex(allocationDimensions, AllocationDimensionIndex.Date)?.id.replace(
        ALLOCATION_DIMENSION_ID_PREFIX,
        ""
    );
    const doorsId = getAllocationDimensionByIndex(allocationDimensions, AllocationDimensionIndex.Door)?.id.replace(
        ALLOCATION_DIMENSION_ID_PREFIX,
        ""
    );

    const deliveriesValues = dimensionValues[deliveriesId] ?? [];
    const doorsValues = dimensionValues[doorsId] ?? [];

    items.forEach((item, index) => {
        let newItem = item;
        const rowId = amphibiousGetIn(item, Item.FIELDS.ID);
        if (itemIds.includes(rowId)) {
            if ([exportOptions.item.name, doubleExportType].includes(exportType)) {
                newItem = newItem.setIn(Item.FIELDS.ITEM_CREATED, exportStatusTime);
            }
            if ([exportOptions.po.name, doubleExportType].includes(exportType)) {
                if (isLegacyBag) {
                    newItem = newItem.setIn(
                        Item.PO_CREATION_BULKS,
                        derivePOTableFromItem(newItem, deliveriesValues, doorsValues)
                    );
                } else {
                    // Convert hardcoded position-based (tech debt) dimension values into dynamic dimension values.
                    // Tech debt eg: Index 0 is delivery, last index is door.
                    const selectedDimensionValues = [];
                    deliveriesValues.length > 0 && selectedDimensionValues.push(deliveriesValues);
                    doorsValues.length > 0 && selectedDimensionValues.push(doorsValues);

                    const allocationBagMutations = generatePOCreationStatusMutations(
                        allocationBag,
                        rowId,
                        selectedDimensionValues
                    );
                    if (allocationBagMutations.length > 0) {
                        actions.push(bulkMutateAllocationBag(collectionId, allocationBagMutations));
                    }
                }
                newItem = newItem.setIn(Item.FIELDS.PO_CREATED, exportStatusTime);
            }
            newItem !== item && actions.push(mutateCollectionItem({ itemsId, index, item: newItem }));
        }
    });

    actions.push(fetchExportLogs(collectionId, true));
    enableToCollectReports &&
        actions.push(
            ...updateExportCountInCollectionFacet({
                driveItem,
                doorTotals,
                shouldIncreaseExportCount,
                shouldSendCollectionReports,
            })
        );
    return actions;
};

type UpdateExportCountInCollectionFacetProps = {
    doorTotals: IDoorTotals;
    driveItem: nuorder.folder.v1.Item;
    shouldIncreaseExportCount?: boolean;
    shouldSendCollectionReports?: boolean;
};

const updateExportCountInCollectionFacet = ({
    doorTotals,
    driveItem,
    shouldSendCollectionReports,
    shouldIncreaseExportCount,
}: UpdateExportCountInCollectionFacetProps) => {
    const exportCount = driveItem?.collection_facet?.export_count ?? 0;
    const actions = [];

    shouldIncreaseExportCount && actions.push(setTransientExportCount(Number(exportCount) + 1));

    if (shouldSendCollectionReports) {
        actions.push(updateCollectionReports(doorTotals));
    }

    return actions;
};

export const exportItemsPOEpic = (action$, store) =>
    action$
        .ofType(COLLECTIONS.COLLECTION.EXPORT_ITEMS.START)
        .map(({ payload }) => payload)
        .mergeMap((payload) => {
            const {
                collectionId,
                selectedOptions,
                selectedAllocationDimensionValues,
                selectedItemIds,
                exportType,
                exportOptions,
                creationIndicator,
                allowUpdate,
            } = payload;

            const state = store.getState();
            const { collection } = state;
            const {
                driveItem: { capabilities },
            } = collection;
            const query = { sid: collection.sessionId };
            const allocationDimensions = getAllocationDimensions(state, collectionId);
            const headers = [
                ...selectedOptions,
                {
                    key: "process_indicator",
                    display_name: "Process Indicator",
                    option_value: {
                        string_value: exportType,
                    },
                },
            ];

            if (creationIndicator && allowUpdate) {
                headers.push({
                    key: "creation_indicator",
                    display_name: "Creation Indicator",
                    option_value: {
                        string_value: creationIndicator,
                    },
                });
            }

            const body: any = {
                collection_id: collectionId,
                merchant_id: collection.merchantId,
                type: ExportRequestType.JsonIngestionFtp,
                row_filter: {
                    in: {
                        field: "id",
                        values: selectedItemIds,
                    },
                },
                selected_options: headers,
                dimension_values: Object.keys(selectedAllocationDimensionValues).reduce(
                    (acc, selectedAllocationDimensionId) => {
                        acc.push({
                            dimension_id: selectedAllocationDimensionId,
                            dimension_values: selectedAllocationDimensionValues[selectedAllocationDimensionId],
                        });
                        return acc;
                    },
                    []
                ),
            };

            const dimensionValues: any = {};
            body.dimension_values.map((element: any) => {
                const selectedAllocationDimension = allocationDimensions.find(
                    (allocationDimension) =>
                        allocationDimension.id.replace(ALLOCATION_DIMENSION_ID_PREFIX, "") === element.dimension_id
                );
                const dimensionName = selectedAllocationDimension
                    ? selectedAllocationDimension.name
                    : element.dimension_id;
                dimensionValues[dimensionName] = element.dimension_values.length;
            });

            WindowAnalytics.track(ExportItemPo.CreateExportItemPo, {
                exportType,
                rows: selectedItemIds.length,
                dimensionValues,
            });

            return ajax({
                body,
                method: "POST",
                url: `${siteConfig.goAPI}/v1/collections/${collectionId}/exports?${stringify(query)}`,
            })
                .mergeMap(({ response }) => {
                    const timezone = moment.tz(moment.tz.guess()).zoneAbbr();
                    const timestamp = moment(+response.collection_export.created_at_ms).format(
                        dateFormat.DATE_FORMAT_WITH_TIME
                    );
                    const exportStatusTime = `${timestamp} ${timezone}`;

                    return getActionsForExportItems({
                        collectionId,
                        dimensionValues: selectedAllocationDimensionValues,
                        itemIds: selectedItemIds.map((id) => id.string_value),
                        exportType,
                        state,
                        exportOptions,
                        exportStatusTime,
                        enableToCollectReports: capabilities?.can_edit,
                        shouldIncreaseExportCount: true,
                        shouldSendCollectionReports: true,
                        driveItem: collection.driveItem,
                        doorTotals: collection.doorTotals,
                    });
                })
                .catch((error) =>
                    Observable.merge(Observable.of(snackbarAdd({ message: `Error: ${error?.message}` })))
                );
        });

export const fetchCollectionDebuggerRevision = (action$, store) => {
    return action$
        .ofType(COLLECTIONS.COLLECTION.DEBUGGER_REVISION.FETCH)
        .map(({ payload }) => payload)
        .flatMap(({ collectionId, debuggerRevision }) => {
            const { sessionId, merchantId } = store.getState().collection;
            const query = {
                sid: sessionId,
                merchant_id: merchantId,
                with_snapshot: true,
                revision: debuggerRevision,
            };
            return ajax(
                `${siteConfig.goAPI}/v1/collections/${collectionId}/collection_objects/${ITEMS_ID}?${stringify(query)}`
            )
                .map(({ response }) => response)
                .flatMap(({ object, ref }) => {
                    const items = translateItemsList(object.mutable_list.values);
                    store.dispatch(listCreate(ITEMS_NAMESPACE, { object_id: `${ref.object_id}-rev` }, items));
                    return ajax(
                        `${siteConfig.goAPI}/v1/collections/${collectionId}/mutations?object_id=${ITEMS_ID}&${stringify(
                            query
                        )}&begin_revision=${debuggerRevision}&end_revision=${debuggerRevision}`
                    )
                        .map(({ response }) => response)
                        .flatMap(({ data }) => {
                            return Observable.of({
                                payload: data[0],
                                type: COLLECTIONS.COLLECTION.DEBUGGER_SNAPSHOT.COMPLETED,
                            });
                        })
                        .catch(() => {
                            return Observable.merge(
                                Observable.of(snackbarAdd({ message: formatMessage("Revision entry not found") }))
                            );
                        });
                })
                .catch(() => {
                    return Observable.merge(
                        Observable.of(snackbarAdd({ message: formatMessage("Revision entry not found") }))
                    );
                });
        });
};

const sendToSentry = (e) => {
    try {
        Sentry.captureException(e);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e); // if all else fails
    }
    // eslint-disable-next-line no-console
    console.error(e);
};
//
